(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2031],{

/***/ 55105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const lodash_1 = __importDefault(__webpack_require__(96486));
const assert_1 = __importDefault(__webpack_require__(27596));
const constants_1 = __webpack_require__(13294);
const LISTED_PRODUCT_TYPE_PATHS = {
    combined: 'hospital-extras-bundle',
    extras: 'extras-cover',
    hospital: 'hospital-cover',
    package: 'hospital-extras-packages',
};
function getProductUrl(args) {
    const { errorUrl, productId, rawUrl } = args || { errorUrl: undefined, productId: undefined, rawUrl: undefined };
    (0, assert_1.default)(lodash_1.default.isString(rawUrl), 'rawUrl must be a string');
    (0, assert_1.default)(lodash_1.default.isString(productId), 'productId must be a string');
    (0, assert_1.default)(lodash_1.default.isString(errorUrl), 'errorUrl must be a string');
    const type = lodash_1.default.findKey(constants_1.PRODUCTS_BY_TYPE, (products) => lodash_1.default.includes(products, productId));
    const parentProductId = lodash_1.default.findKey(constants_1.PRODUCTS_BY_PARENT, (products) => lodash_1.default.includes(products, productId));
    if (lodash_1.default.isUndefined(type) || lodash_1.default.isUndefined(productId)) {
        return errorUrl;
    }
    const productUrl = (0, lodash_1.default)(rawUrl)
        .replace(':type', LISTED_PRODUCT_TYPE_PATHS[type])
        .replace(':id', parentProductId || lodash_1.default.replace(productId, /(\b-excess-)[0-9]*/, ''));
    return productUrl;
}
module.exports = {
    getProductUrl,
};


/***/ }),

/***/ 63580:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-insurance/choose-your-cover",
      function () {
        return __webpack_require__(27187);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72898:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/ellipse.f96deaee.svg","height":24,"width":24});

/***/ }),

/***/ 27187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/client/types/__codegen__/ahm-api/graphql.ts
var graphql = __webpack_require__(7473);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/constants.ts

var STEPS = {
    ABOUT_YOU: "About you",
    CHOOSE_THE_COVER: "Choose the cover",
    EXTRAS_SERVICES: "Extras services",
    HOSPITAL_SERVICES: "Hospital services",
    SPLASH_SCREEN: "Splash screen"
};
var _obj;
var analyticsLabels = (_obj = {}, (0,_define_property/* default */.Z)(_obj, STEPS.ABOUT_YOU, "About"), (0,_define_property/* default */.Z)(_obj, STEPS.CHOOSE_THE_COVER, "Choose cover"), (0,_define_property/* default */.Z)(_obj, STEPS.EXTRAS_SERVICES, "Extras"), (0,_define_property/* default */.Z)(_obj, STEPS.HOSPITAL_SERVICES, "Hospital"), _obj);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./src/client/pages/refine-price/form/refine-price-form-fields/index.tsx + 1 modules
var refine_price_form_fields = __webpack_require__(4251);
;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/components/step-footer-navigation/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 4.5rem;\n  border-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    position: relative;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto 1rem;\n  width: 100%;\n  font-size: 1rem;\n\n  @media (min-width: ",
        ") {\n    margin: 0;\n    width: auto;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 1rem;\n  font-weight: ",
        ";\n  font-size: 0.875rem;\n\n  @media (min-width: ",
        ") {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 2.5rem;\n  right: 0;\n  position: absolute;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledWrapper = (0,styled_components_browser_esm["default"])(ahm_ui/* SpacerWrapper */.Cj).withConfig({
    componentId: "sc-2e946f0d-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.colors.grey20);
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-2e946f0d-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var StyledClickable = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-2e946f0d-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.fontWeights.bold;
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var ForwardButtonsWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-2e946f0d-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/components/forward-buttons/index.tsx






var ForwardButtons = function(param) {
    var onNextClick = param.onNextClick;
    var ref = (0,ahm_ui/* useStepperContext */.sF)(), activeStep = ref.activeStep, goToNextStep = ref.goToNextStep, steps = ref.steps;
    var isLastStep = activeStep === (0,fp.last)(steps);
    var isServicesStep = activeStep === null || activeStep === void 0 ? void 0 : activeStep.includes("services");
    var handleOnNextClick = function() {
        if (onNextClick) {
            onNextClick();
        } else {
            goToNextStep();
        }
    };
    if (!isServicesStep && isLastStep) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isServicesStep && goToNextStep && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledClickable, {
                analytics: {
                    label: "Skip - ".concat(analyticsLabels[activeStep])
                },
                onClick: goToNextStep,
                children: "Skip"
            }),
            !isLastStep && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                analytics: {
                    label: "Next - ".concat(analyticsLabels[activeStep])
                },
                onClick: handleOnNextClick,
                children: "Next"
            })
        ]
    });
};
/* harmony default export */ var forward_buttons = (ForwardButtons);

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/components/step-footer-navigation/index.tsx







var StepFooterNavigation = function(param) {
    var onNextClick = param.onNextClick;
    var ref = (0,ahm_ui/* useStepperContext */.sF)(), activeStep = ref.activeStep, goToPreviousStep = ref.goToPreviousStep, steps = ref.steps;
    var isLastStep = activeStep === (0,fp.last)(steps);
    var isFirstStep = activeStep === (steps === null || steps === void 0 ? void 0 : steps[0]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Wrapper */.im, {
        size: "large",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
            isLastStep: isLastStep,
            variant: [
                "paddingTopSpacer8",
                "paddingBottomSpacer10"
            ],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                    df: true,
                    lg: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(forward_buttons, {
                        onNextClick: onNextClick
                    })
                }),
                goToPreviousStep && !isFirstStep && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                    analytics: {
                        label: "Back - ".concat(analyticsLabels[activeStep])
                    },
                    variant: [
                        "white",
                        "border"
                    ],
                    onClick: goToPreviousStep,
                    children: "Back"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                    xs: true,
                    sm: true,
                    md: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardButtonsWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(forward_buttons, {
                            onNextClick: onNextClick
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var step_footer_navigation = (StepFooterNavigation);

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/steps/about-you/form/index.tsx






var AboutYouForm = function(param) {
    var captureFormState = param.captureFormState;
    var ref = (0,formik_esm.useFormikContext)(), errors = ref.errors, handleSubmit = ref.handleSubmit, submitCount = ref.submitCount, touched = ref.touched;
    var setFormikTouched = captureFormState === null || captureFormState === void 0 ? void 0 : captureFormState.setFormikTouched;
    var setFormikErrors = captureFormState === null || captureFormState === void 0 ? void 0 : captureFormState.setFormikErrors;
    // ErrorSummary component requires formik context values. This allows us to pass the errors and touched objects outside the LeadCaptureForm
    (0,react.useEffect)(function() {
        if (setFormikErrors) {
            setFormikErrors(errors);
        }
    }, [
        errors,
        setFormikErrors
    ]);
    (0,react.useEffect)(function() {
        if (setFormikTouched) {
            setFormikTouched(touched);
        }
    }, [
        touched,
        setFormikTouched
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm.Form, {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Wrapper */.im, {
                size: "small",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(refine_price_form_fields/* default */.Z, {
                    hasSubmitAttempt: Boolean(submitCount),
                    showPaymentFrequency: false
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(step_footer_navigation, {
                onNextClick: handleSubmit
            })
        ]
    });
};
/* harmony default export */ var about_you_form = (AboutYouForm);

// EXTERNAL MODULE: ./src/client/pages/refine-price/utils/build-submit-handler/index.ts
var build_submit_handler = __webpack_require__(51890);
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
// EXTERNAL MODULE: ./src/client/actions/customer/index.ts
var customer = __webpack_require__(91395);
// EXTERNAL MODULE: ./src/client/pages/refine-price/form/schema/index.ts
var schema = __webpack_require__(25034);
// EXTERNAL MODULE: ./src/client/selectors/select-customer/index.ts + 2 modules
var select_customer = __webpack_require__(34112);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/selectors/select-customer-form-initial-values/index.ts
var select_customer_form_initial_values = __webpack_require__(33628);
;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/steps/about-you/index.tsx



function about_you_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: left;\n"
    ]);
    about_you_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var ErrorSummaryWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9fbb3c4-0"
})(about_you_templateObject());
var SCROLL_OFFSET = 100;
var schemaForErrorSummary = {
    age: {
        linkPhrases: [
            "age"
        ]
    },
    partnerAge: {
        linkPhrases: [
            "partner’s age"
        ]
    }
};
var errorOrder = [
    "age",
    "partnerAge"
];
var AboutYou = function(param) {
    var actions = param.actions;
    var ref = (0,react.useState)({}), formikErrors = ref[0], setFormikErrors = ref[1];
    var ref1 = (0,react.useState)({}), formikTouched = ref1[0], setFormikTouched = ref1[1];
    var goToNextStep = (0,ahm_ui/* useStepperContext */.sF)().goToNextStep;
    var initialValues = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,es/* useSelector */.v9)(select_customer_form_initial_values/* default */.Z)), {
        productType: ahm_constants/* default.PRODUCT_TYPE.PACKAGE */.Z.PRODUCT_TYPE.PACKAGE
    });
    var customer = (0,es/* useSelector */.v9)(select_customer/* default */.Z);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Wrapper */.im, {
                size: "small",
                children: [
                    !(0,fp.isEmpty)(formikErrors) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorSummaryWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* ErrorSummary */.Xg, {
                            schema: schemaForErrorSummary,
                            errors: (0,fp.pick)(errorOrder, formikErrors),
                            touched: formikTouched
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H1, {
                        looksLike: "h2",
                        children: "About you"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                        variant: "marginBottomSpacer10",
                        children: "Feeling a bit shy? Tell us a bit about yourself, so we can find you a perfect match."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm.Formik, {
                    enableReinitialize: true,
                    validationSchema: schema/* default */.Z,
                    initialValues: initialValues,
                    onSubmit: function(values) {
                        (0,build_submit_handler/* default */.Z)({
                            actions: actions,
                            customer: customer,
                            formValues: values,
                            initialValues: initialValues
                        });
                        goToNextStep();
                    },
                    children: function(param) {
                        var errors = param.errors, isSubmitting = param.isSubmitting;
                        if (isSubmitting && !(0,fp.isEmpty)(errors)) {
                            (0,ahm_ui/* scrollToFirstError */.rD)({
                                offset: SCROLL_OFFSET
                            });
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(about_you_form, {
                            captureFormState: {
                                setFormikErrors: setFormikErrors,
                                setFormikTouched: setFormikTouched
                            }
                        });
                    }
                })
            })
        ]
    });
};
var mapDispatchToProps = function(dispatch) {
    return {
        actions: {
            customer: (0,redux/* bindActionCreators */.DE)(customer/* default */.Z, dispatch)
        }
    };
};
/* harmony default export */ var about_you = ((0,es/* connect */.$j)(null, mapDispatchToProps)(AboutYou));

// EXTERNAL MODULE: ./node_modules/@ahmdigital/constants/lib/src/index.js
var src = __webpack_require__(13294);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/utils/get-parent-product-id/index.js
var get_parent_product_id = __webpack_require__(36529);
var get_parent_product_id_default = /*#__PURE__*/__webpack_require__.n(get_parent_product_id);
// EXTERNAL MODULE: ./src/client/pages/product/components/cart-price/styles.ts
var styles = __webpack_require__(11857);
// EXTERNAL MODULE: ./src/client/components/step-list/images/ellipse.svg
var ellipse = __webpack_require__(72898);
;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/steps/choose-your-cover/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: stretch;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 2rem;\n  margin-top: 1.5rem;\n\n  @media (min-width: ",
        ") {\n    align-items: center;\n    flex-direction: row;\n    margin-bottom: 2.6rem;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: linear-gradient(\n    to right,\n    ",
        " 65%,\n    ",
        " 0%\n  );\n  background-position: bottom;\n  background-size: 10px 1px;\n  background-repeat: repeat-x;\n  padding-bottom: 1.5rem;\n  text-align: center;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &::before {\n    content: ",
        ";\n    color: ",
        ";\n    font-size: 1rem;\n    display: inline-block;\n    font-family: ",
        ";\n    font-weight: bold;\n    text-align: center;\n    margin-right: 0.5rem;\n    width: 1.5rem;\n    height: 1.5rem;\n    background-color: ",
        ";\n    mask-image: url('",
        "');\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1rem;\n\n  @media (min-width: ",
        ") {\n    margin-left: 1rem;\n    margin-top: 0;\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  > ul {\n    min-width: fit-content;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  button {\n    padding: 0 0.5rem;\n\n    &:focus {\n      outline-offset: 0;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: baseline;\n\n  @media (min-width: ",
        ") {\n    align-items: baseline;\n    display: flex;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 0;\n  padding-right: 0.25rem;\n  display: inline-block;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 1rem;\n  margin-bottom: 1.625rem;\n  display: inline-block;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transition: left cubic-bezier(0.25, 0.01, 0.25, 1) 0.2s;\n  position: relative;\n  scroll-snap-align: start;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 0.875rem;\n  margin-bottom: 0.5rem;\n  display: block;\n  margin-left: 1rem;\n  @media (min-width: ",
        ") {\n    margin-left: 1.4rem;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 0 3.5rem 0;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 397px;\n  background-color: ",
        ";\n  margin: 0 1rem 1rem 1rem;\n  flex-direction: column;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var DisclaimerWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d7a149de-0"
})(styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var HeaderWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d7a149de-1"
})(styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.grey20;
}, function(param) {
    var theme = param.theme;
    return theme.colors.grey10;
});
var StyledH3 = (0,styled_components_browser_esm["default"])(ahm_ui.H3).withConfig({
    componentId: "sc-d7a149de-2"
})(styles_templateObject2(), function(param) {
    var $counterIndex = param.$counterIndex;
    return '"'.concat($counterIndex, '"');
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.fontFamilies.secondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.purple;
}, ellipse/* default.src */.Z.src);
var styles_StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-d7a149de-3"
})(styles_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var SoftBundleListbox = (0,styled_components_browser_esm["default"])(styles/* StyledListbox */.C).withConfig({
    componentId: "sc-d7a149de-4"
})(_templateObject4());
var PaymentOptionsWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d7a149de-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var Label = (0,styled_components_browser_esm["default"])(ahm_ui.P).withConfig({
    componentId: "sc-d7a149de-6"
})(_templateObject6());
var PaymentOption = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d7a149de-7"
})(_templateObject7());
var MovingColumn = (0,styled_components_browser_esm["default"])(ahm_ui/* Col */.JX).withConfig({
    componentId: "sc-d7a149de-8"
})(_templateObject8());
var SmallErrorText = styled_components_browser_esm["default"].small.withConfig({
    componentId: "sc-d7a149de-9"
})(_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.colors.redDark;
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var StyledSection = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-d7a149de-10"
})(_templateObject10());
var LoadingContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d7a149de-11"
})(_templateObject11(), function(param) {
    var theme = param.theme;
    return theme.colors.grey10;
});

// EXTERNAL MODULE: ./src/client/ahm-constants/ui.ts
var ui = __webpack_require__(93590);
// EXTERNAL MODULE: ./src/client/analytics/google/constants.ts
var constants = __webpack_require__(5331);
// EXTERNAL MODULE: ./src/client/models/url/constants.ts
var url_constants = __webpack_require__(772);
// EXTERNAL MODULE: ./src/client/analytics/index.ts + 6 modules
var analytics = __webpack_require__(86039);
// EXTERNAL MODULE: ./src/client/utils/browser.ts
var browser = __webpack_require__(40055);
// EXTERNAL MODULE: ./src/client/actions/build-your-cover/index.ts
var build_your_cover = __webpack_require__(78937);
// EXTERNAL MODULE: ./src/client/pages/product/util/use-is-from-choose-your-cover/index.tsx
var use_is_from_choose_your_cover = __webpack_require__(96901);
// EXTERNAL MODULE: ./src/client/components/loading-spinner/index.tsx
var loading_spinner = __webpack_require__(30950);
// EXTERNAL MODULE: ./src/client/utils/prepare-products-for-product-tiles/index.ts
var prepare_products_for_product_tiles = __webpack_require__(95327);
// EXTERNAL MODULE: ./src/client/selectors/select-prices/index.ts
var select_prices = __webpack_require__(1318);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/utils/truncate-frequency/index.ts
var truncate_frequency = __webpack_require__(34237);
;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/steps/choose-your-cover/components/carousel-tiles/index.tsx

















var CarouselTiles = function(param) {
    var products = param.products, hasBestSellerWithFewerInclusions = param.hasBestSellerWithFewerInclusions, isExpanded = param.isExpanded, isStuck = param.isStuck, handleToggle = param.handleToggle;
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var customer = (0,es/* useSelector */.v9)(select_customer/* default */.Z);
    var prices = (0,es/* useSelector */.v9)(select_prices/* default */.Z);
    var selectedProducts = (0,es/* useSelector */.v9)(function(state) {
        return state.buildYourCover;
    }).selectedProducts;
    var useFutureEffectiveDate = (0,es/* useSelector */.v9)(function(state) {
        return state.price.useFutureEffectiveDate;
    });
    var isBuildYourCoverProductType = function(productType) {
        return productType === src.PRODUCT_TYPE.EXTRAS || productType === src.PRODUCT_TYPE.HOSPITAL;
    };
    var handleProductSelect = (0,react.useCallback)(function(productType, productId) {
        if (isBuildYourCoverProductType(productType)) {
            dispatch(build_your_cover/* default.setOrUnsetSelectedProduct */.Z.setOrUnsetSelectedProduct(productType, productId));
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        dispatch
    ]);
    if ((0,fp.isEmpty)(products)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_spinner/* default */.Z, {});
    }
    var expandoProducts = (0,ahm_ui/* populateExpandoServiceData */.Vk)(products);
    var mappedProducts = expandoProducts.map(function(product) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,fp.omit)([
            src.PRODUCT_TYPE.EXTRAS,
            src.PRODUCT_TYPE.HOSPITAL
        ], product)), (0,_define_property/* default */.Z)({}, "".concat(product.type, "Services"), (0,ahm_ui/* transformServicesList */.AQ)(product, product.type)));
    });
    var tilesProductType = (ref = products[0]) === null || ref === void 0 ? void 0 : ref.type;
    var allServices = (0,ahm_ui/* getServiceRows */.J8)(mappedProducts, tilesProductType);
    var treatedProducts = (0,prepare_products_for_product_tiles/* default */.Z)(products, customer, prices, useFutureEffectiveDate);
    var selectedProductId = selectedProducts[tilesProductType];
    var productIds = (0,fp.map)("id", products);
    if (selectedProductId && !(0,fp.includes)(selectedProductId, productIds)) {
        handleProductSelect(tilesProductType, selectedProductId);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: treatedProducts.map(function(product) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(MovingColumn, {
                variant: "extraThinGutter",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* ProductTile */.vB, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                    url: "".concat(product === null || product === void 0 ? void 0 : product.url, "?").concat(use_is_from_choose_your_cover/* IS_CHOOSE_YOUR_COVER */.Z, "=true"),
                    onToggle: handleToggle,
                    handleSelect: handleProductSelect,
                    isBestSeller: product === null || product === void 0 ? void 0 : product.isBestSeller,
                    isExpandable: true,
                    isExpanded: isExpanded,
                    isBestSellerWithFewerInclusions: hasBestSellerWithFewerInclusions,
                    isStuck: isStuck,
                    ctaIcon: "plus-circle",
                    ctaText: "Add cover",
                    scale: product === null || product === void 0 ? void 0 : product.scale,
                    selectedProductId: selectedProductId,
                    services: allServices,
                    frequency: (0,truncate_frequency/* default */.Z)(customer.frequency),
                    price: product === null || product === void 0 ? void 0 : product.price
                }))
            }, product === null || product === void 0 ? void 0 : product.id);
        })
    });
};
/* harmony default export */ var carousel_tiles = (CarouselTiles);

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/utils/get-carousel-start-index/index.ts

var getCarouselStartIndex = function(recommendedProductId, products, selectedProductId) {
    var index = 0;
    if ((0,fp.isEmpty)(products)) return index;
    if (selectedProductId) {
        index = products.findIndex(function(product) {
            return product.id === selectedProductId;
        });
    } else {
        index = products.findIndex(function(product) {
            return (product.parentProductId || product.id) === recommendedProductId;
        });
    }
    return index === -1 ? 0 : index;
};
/* harmony default export */ var get_carousel_start_index = (getCarouselStartIndex);

// EXTERNAL MODULE: ./src/client/utils/get-frequency-options/index.tsx
var get_frequency_options = __webpack_require__(26089);
// EXTERNAL MODULE: ./src/client/utils/hospital-excess-to-options/index.ts
var hospital_excess_to_options = __webpack_require__(31063);
// EXTERNAL MODULE: ./src/client/components/premium-review-toggle-wrapper/index.tsx + 2 modules
var premium_review_toggle_wrapper = __webpack_require__(12224);
;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/steps/components/payment-toggles/index.tsx











var PaymentToggles = function(param) {
    var productType = param.productType;
    var ref = (0,es/* useSelector */.v9)(select_customer/* default */.Z), frequency = ref.frequency, hospitalExcess = ref.hospitalExcess;
    var dispatch = (0,es/* useDispatch */.I0)();
    var onChangeFrequency = (0,react.useCallback)(function(newFrequency) {
        dispatch(customer/* default.changeFrequency */.Z.changeFrequency(newFrequency));
    }, [
        dispatch
    ]);
    var onChangeExcess = (0,react.useCallback)(function(excess) {
        dispatch(customer/* default.changeHospitalExcess */.Z.changeHospitalExcess(excess));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentOptionsWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(premium_review_toggle_wrapper/* default */.ZP, {
                hasEvenSpacing: true,
                hasMargin: false,
                showBackground: false,
                type: ui.PREMIUM_REVIEW_TOGGLE_STYLE.SOFT_BUNDLE_PAGE
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                children: "Paying"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOption, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SoftBundleListbox, {
                    id: "frequency",
                    label: "frequency",
                    ariaLabel: "frequency",
                    value: frequency,
                    options: (0,get_frequency_options/* default */.Z)({
                        endText: "ly"
                    }),
                    onChange: onChangeFrequency
                })
            }),
            productType === src.PRODUCT_TYPE.HOSPITAL && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                        children: "Excess"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOption, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SoftBundleListbox, {
                            label: "excess",
                            ariaLabel: "excess",
                            value: hospitalExcess,
                            options: (0,hospital_excess_to_options/* default */.Z)(ui.EXCESS_TYPES),
                            onChange: onChangeExcess,
                            softBundlePage: true
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var payment_toggles = (PaymentToggles);

// EXTERNAL MODULE: ./node_modules/@apollo/client/index.js
var client = __webpack_require__(46829);
// EXTERNAL MODULE: ./src/client/graphql/client/index.ts
var graphql_client = __webpack_require__(84128);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/index.js
var core = __webpack_require__(71439);
;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/queries/fetch-recommended-products/query.ts

function query_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query fetchRecommendedProducts($input: RecommendProductsInput) {\n    recommendProducts(input: $input) {\n      extras\n      hospital\n    }\n  }\n"
    ]);
    query_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var RECOMMENDED_PRODUCTS = (0,core.gql)(query_templateObject());
/* harmony default export */ var query = (RECOMMENDED_PRODUCTS);

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/utils/use-get-recommended-products/index.tsx




var useGetRecommendedProductsByAgeAndScale = function(dob, scale, selectedServices) {
    var ref, ref1;
    var selectedExtras = selectedServices.extras, selectedHospital = selectedServices.hospital;
    var data = (0,client.useQuery)(query, {
        client: graphql_client/* default */.Z,
        variables: {
            input: {
                dob: dob,
                scale: scale
            }
        }
    }).data;
    return {
        extras: (0,fp.isEmpty)(selectedExtras) ? data === null || data === void 0 ? void 0 : (ref = data.recommendProducts) === null || ref === void 0 ? void 0 : ref.extras : null,
        hospital: (0,fp.isEmpty)(selectedHospital) ? data === null || data === void 0 ? void 0 : (ref1 = data.recommendProducts) === null || ref1 === void 0 ? void 0 : ref1.hospital : null
    };
};
/* harmony default export */ var use_get_recommended_products = (useGetRecommendedProductsByAgeAndScale);

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/steps/choose-your-cover/components/carousel-section/index.tsx












var LoadingScreen = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoadingContainer, {
        "aria-busy": "true",
        "aria-live": "polite",
        role: "status",
        "aria-label": "Loading products",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Spinner */.$j, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                children: "Loading products"
            })
        ]
    });
};
var HOSPITAL = src.PRODUCT_TYPE.HOSPITAL;
var CarouselSection = function(param) {
    var hasBestSellerWithFewerInclusions = param.hasBestSellerWithFewerInclusions, isStuck = param.isStuck, productType = param.productType, products = param.products, sectionRef = param.sectionRef;
    var ref;
    var ref1 = (0,react.useState)(false), isExpanded = ref1[0], setIsExpanded = ref1[1];
    var ref2 = (0,react.useState)(0), activeIndex = ref2[0], setActiveIndex = ref2[1];
    var ref3 = (0,es/* useSelector */.v9)(select_customer/* default */.Z), members = ref3.members, scale = ref3.scale;
    var ref4 = (0,es/* useSelector */.v9)(function(state) {
        return state.buildYourCover;
    }), selectedServices = ref4.selectedServices, selectedProducts = ref4.selectedProducts, invalidProductTypes = ref4.invalidProductTypes;
    var handleToggle = function() {
        setIsExpanded(!isExpanded);
    };
    var handleMoveLeft = function() {
        if (activeIndex > 0) {
            setActiveIndex(activeIndex - 1);
        }
    };
    var handleMoveRight = function() {
        if (activeIndex < products.length - 1) {
            setActiveIndex(activeIndex + 1);
        }
    };
    var recommendedProducts = use_get_recommended_products(members === null || members === void 0 ? void 0 : (ref = members[0]) === null || ref === void 0 ? void 0 : ref.dob, scale, selectedServices);
    (0,react.useEffect)(function() {
        setActiveIndex(get_carousel_start_index(recommendedProducts[productType], products, selectedProducts[productType]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        recommendedProducts[productType],
        products === null || products === void 0 ? void 0 : products.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
        ref: sectionRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledH3, {
                $counterIndex: productType === HOSPITAL ? 1 : 2,
                looksLike: "h5",
                children: [
                    "Select ",
                    productType,
                    " cover"
                ]
            }),
            (0,fp.includes)(productType, invalidProductTypes) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmallErrorText, {
                children: [
                    "Please select ",
                    productType,
                    " cover to continue."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_toggles, {
                productType: productType
            }),
            (products === null || products === void 0 ? void 0 : products.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* ProductCarousel */.GM, {
                productCount: products.length,
                isExpanded: isExpanded,
                isStuck: isStuck,
                activeIndex: activeIndex,
                handleMoveLeft: handleMoveLeft,
                handleMoveRight: handleMoveRight,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel_tiles, {
                    products: products,
                    hasBestSellerWithFewerInclusions: hasBestSellerWithFewerInclusions,
                    isExpanded: isExpanded,
                    isStuck: isStuck,
                    handleToggle: handleToggle
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingScreen, {})
        ]
    });
};
/* harmony default export */ var carousel_section = (CarouselSection);

// EXTERNAL MODULE: ./src/client/actions/drawer/index.ts
var drawer = __webpack_require__(56774);
// EXTERNAL MODULE: ./src/client/utils/customer-has-changed/index.ts
var customer_has_changed = __webpack_require__(51552);
// EXTERNAL MODULE: ./src/client/utils/get-future-date/index.tsx
var get_future_date = __webpack_require__(84701);
// EXTERNAL MODULE: ./src/client/selectors/select-filtered-products-by-customer/index.ts + 1 modules
var select_filtered_products_by_customer = __webpack_require__(82178);
;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/utils/get-selector/index.tsx

var getSelector = function(productIds, state) {
    if (!productIds) return null;
    return (0,select_filtered_products_by_customer/* default */.Z)(state, {
        match: {
            params: {
                productIds: productIds
            }
        }
    });
};
/* harmony default export */ var get_selector = (getSelector);

// EXTERNAL MODULE: ./src/client/pages/build-your-cover/utils/get-unavailable-product-props/index.ts
var get_unavailable_product_props = __webpack_require__(1565);
// EXTERNAL MODULE: ./src/client/actions/price/index.ts
var price = __webpack_require__(77061);
// EXTERNAL MODULE: ./src/client/components/price-disclaimer/index.tsx + 2 modules
var price_disclaimer = __webpack_require__(76383);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/index.tsx + 7 modules
var pricing_drawer = __webpack_require__(87022);
// EXTERNAL MODULE: ./src/client/models/product/index.ts + 32 modules
var product = __webpack_require__(43735);
// EXTERNAL MODULE: ./src/client/utils/redirect-adapter/index.tsx
var redirect_adapter = __webpack_require__(18971);
;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/utils/refine-products-by-parent-id/index.ts

var refineProductsByParentId = function(parentProductIds, products) {
    return (0,fp.compact)((0,fp.map)(function(parentProductId) {
        var filteredItems = (0,fp.filter)({
            parentProductId: parentProductId
        }, products);
        return (0,fp.find)({
            unavailableWithExcessInfo: null
        }, filteredItems) || (0,fp.first)(filteredItems);
    }, parentProductIds));
};
/* harmony default export */ var refine_products_by_parent_id = (refineProductsByParentId);

// EXTERNAL MODULE: ./src/client/selectors/select-products/index.ts
var select_products = __webpack_require__(2664);
;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/utils/get-best-seller/index.tsx

var _scale;
var getBestSeller = function(param) {
    var productType = param.productType, scale = param.scale;
    return (_scale = ui.BEST_SELLERS_PRODUCT_LIST[productType][scale]) !== null && _scale !== void 0 ? _scale : null;
}; // Null as there may not be a best seller for the given product type
/* harmony default export */ var get_best_seller = (getBestSeller);

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/utils/get-product-id-list-and-has-best-seller/index.tsx


var getProductIdListAndHasBestSeller = function(loadingState, errorState, productData, productType, scale) {
    var ref;
    var productIds = (ref = productData === null || productData === void 0 ? void 0 : productData.productsWithServices) !== null && ref !== void 0 ? ref : [];
    if (loadingState || errorState || productIds.length > 1) {
        return {
            hasBestSellerWithFewerInclusions: false,
            productIds: productIds
        };
    }
    return {
        hasBestSellerWithFewerInclusions: true,
        productIds: (0,_to_consumable_array/* default */.Z)(productIds).concat([
            get_best_seller({
                productType: productType,
                scale: scale
            })
        ])
    };
};
/* harmony default export */ var get_product_id_list_and_has_best_seller = (getProductIdListAndHasBestSeller);

// EXTERNAL MODULE: ./src/client/utils/get-saleable-product-ids/index.ts
var get_saleable_product_ids = __webpack_require__(93216);
// EXTERNAL MODULE: ./src/client/actions/product/index.ts
var actions_product = __webpack_require__(15311);
;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/queries/fetch-products-with-services/query.ts

function fetch_products_with_services_query_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query fetchProductsWithServices($input: ProductWithServiceInput) {\n    productsWithServices(input: $input)\n  }\n"
    ]);
    fetch_products_with_services_query_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PRODUCTS_WITH_SERVICES = (0,core.gql)(fetch_products_with_services_query_templateObject());
/* harmony default export */ var fetch_products_with_services_query = (PRODUCTS_WITH_SERVICES);

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/utils/use-get-suitable-products/index.tsx










var useGetSuitableProductIds = function(param) {
    var customer = param.customer, extrasServices = param.extrasServices, hospitalServices = param.hospitalServices;
    var hospitalExcess = customer === null || customer === void 0 ? void 0 : customer.hospitalExcess;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,client.useQuery)(fetch_products_with_services_query, {
        client: graphql_client/* default */.Z,
        variables: {
            input: {
                productType: src.PRODUCT_TYPE.EXTRAS,
                serviceIds: extrasServices
            }
        }
    }), extrasData = ref.data, extrasLoading = ref.loading, extrasError = ref.error;
    var ref1 = (0,client.useQuery)(fetch_products_with_services_query, {
        client: graphql_client/* default */.Z,
        variables: {
            input: {
                productType: src.PRODUCT_TYPE.HOSPITAL,
                serviceIds: hospitalServices
            }
        }
    }), hospitalData = ref1.data, hospitalLoading = ref1.loading, hospitalError = ref1.error;
    var ref2 = get_product_id_list_and_has_best_seller(extrasLoading, Boolean(extrasError), extrasData, src.PRODUCT_TYPE.EXTRAS, customer.scale), extrasProductIds = ref2.productIds, hasExtrasBestSellerWithFewerInclusions = ref2.hasBestSellerWithFewerInclusions;
    var ref3 = get_product_id_list_and_has_best_seller(hospitalLoading, Boolean(hospitalError), hospitalData, src.PRODUCT_TYPE.HOSPITAL, customer.scale), hospitalParentProductIds = ref3.productIds, hasHospitalBestSellerWithFewerInclusions = ref3.hasBestSellerWithFewerInclusions;
    var isLoading = extrasLoading || hospitalLoading;
    var hasError = Boolean(extrasError || hospitalError);
    // we need to get all saleable product ids, to allow products unavailable at the current excess to be loaded
    var saleableProductIds = (0,get_saleable_product_ids/* default */.Z)();
    (0,react.useEffect)(function() {
        var productIdsToLoad = (0,fp.concat)(extrasProductIds, saleableProductIds);
        var action = actions_product/* default.load */.Z.load(productIdsToLoad);
        dispatch(action);
    }, [
        hospitalExcess,
        isLoading,
        JSON.stringify(hospitalParentProductIds, extrasProductIds)
    ]);
    return {
        extrasProductIds: extrasProductIds,
        hasError: hasError,
        hasExtrasBestSellerWithFewerInclusions: hasExtrasBestSellerWithFewerInclusions,
        hasHospitalBestSellerWithFewerInclusions: hasHospitalBestSellerWithFewerInclusions,
        hospitalParentProductIds: hospitalParentProductIds,
        isLoading: isLoading
    };
};
/* harmony default export */ var use_get_suitable_products = (useGetSuitableProductIds);

// EXTERNAL MODULE: ./src/client/utils/ui.ts
var utils_ui = __webpack_require__(85500);
// EXTERNAL MODULE: ./src/client/selectors/select-build-your-cover/index.ts
var select_build_your_cover = __webpack_require__(54251);
;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/steps/choose-your-cover/components/validation-alert/index.tsx

function validation_alert_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n"
    ]);
    validation_alert_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var BoldClickable = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-a903959c-0"
})(validation_alert_templateObject(), function(param) {
    var theme = param.theme;
    return theme.fontWeights.bold;
});
var ValidationAlert = function(param) {
    var hospitalSectionRef = param.hospitalSectionRef, extrasSectionRef = param.extrasSectionRef;
    var invalidProductTypes = (0,es/* useSelector */.v9)(select_build_your_cover/* default */.Z).invalidProductTypes;
    var errorRef = /*#__PURE__*/ react.createRef();
    (0,react.useEffect)(function() {
        if (!(0,fp.isEmpty)(invalidProductTypes) && errorRef.current) {
            (0,utils_ui/* scrollToElement */.kI)(errorRef.current);
        }
    }, [
        invalidProductTypes
    ]);
    if ((0,fp.isEmpty)(invalidProductTypes)) {
        return null;
    }
    var scrollToError = function(productType) {
        (0,utils_ui/* scrollToElement */.kI)((productType === "hospital" ? hospitalSectionRef : extrasSectionRef).current);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: errorRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Alert */.bZ, {
            heading: "Please select your cover to continue.",
            level: "danger",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* List */.aV, {
                variant: [
                    "inside"
                ],
                children: (0,fp.map)(function(productType) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "Select ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoldClickable, {
                                onClick: function() {
                                    return scrollToError(productType);
                                },
                                children: [
                                    productType,
                                    " cover"
                                ]
                            })
                        ]
                    }, "choose-your-cover-error-missing-".concat(productType));
                }, (0,fp.reverse)(invalidProductTypes))
            })
        })
    });
};
/* harmony default export */ var validation_alert = (ValidationAlert);

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/steps/choose-your-cover/index.tsx





































var EXTRAS = src.PRODUCT_TYPE.EXTRAS, choose_your_cover_HOSPITAL = src.PRODUCT_TYPE.HOSPITAL;
var ChooseYourCover = function(param) {
    var actions = param.actions, customer = param.customer, products = param.products, selectedProducts = param.selectedProducts, useFutureEffectiveDate = param.useFutureEffectiveDate;
    var dispatch = (0,es/* useDispatch */.I0)();
    var windowService = browser/* default.getWindow */.Z.getWindow();
    var hospitalExcess = customer.hospitalExcess, scale = customer.scale;
    var customerHasChanged = (0,customer_has_changed/* default */.Z)(customer, useFutureEffectiveDate);
    var hospitalSectionRef = /*#__PURE__*/ react.createRef();
    var extrasSectionRef = /*#__PURE__*/ react.createRef();
    var ref = (0,react.useState)(null), carouselStuck = ref[0], setCarouselStuck = ref[1];
    var ref1 = (0,react.useState)([]), hospitalProducts = ref1[0], setHospitalProducts = ref1[1];
    var selectedServices = (0,es/* useSelector */.v9)(function(state) {
        return state.buildYourCover;
    }).selectedServices;
    var ref2 = use_get_suitable_products({
        customer: customer,
        extrasServices: selectedServices.extras,
        hospitalServices: selectedServices.hospital
    }), extrasProductIds = ref2.extrasProductIds, hasExtrasBestSellerWithFewerInclusions = ref2.hasExtrasBestSellerWithFewerInclusions, hasHospitalBestSellerWithFewerInclusions = ref2.hasHospitalBestSellerWithFewerInclusions, hasError = ref2.hasError, isLoading = ref2.isLoading, hospitalParentProductIds = ref2.hospitalParentProductIds;
    var extrasProducts = (0,es/* useSelector */.v9)(function(state) {
        return get_selector(extrasProductIds, state);
    });
    var hasBestSellerWithFewerInclusions = hasExtrasBestSellerWithFewerInclusions || hasHospitalBestSellerWithFewerInclusions;
    // this returns the actual products that match the product ids
    var allHospitalProducts = (0,fp.flow)((0,fp.filter)(function(product) {
        return (0,fp.includes)(product.parentProductId, hospitalParentProductIds);
    }), (0,fp.map)(function(product) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
            unavailableWithExcessInfo: (0,get_unavailable_product_props/* default */.Z)(actions.customer.changeHospitalExcess, hospitalExcess, product)
        });
    }), fp.compact)(products);
    var refinedProducts = refine_products_by_parent_id(hospitalParentProductIds, allHospitalProducts);
    var productsAvailableByScale = (0,fp.filter)(function(product) {
        var ref;
        return (0,fp.includes)(customer.scale, (ref = product.scales) === null || ref === void 0 ? void 0 : ref.supported);
    }, refinedProducts);
    var productIds = (0,fp.map)("id", (0,fp.concat)(extrasProducts, hospitalProducts));
    var stringedHospitalAndExtrasProducts = JSON.stringify([
        extrasProducts,
        hospitalProducts
    ]);
    (0,react.useEffect)(function() {
        setHospitalProducts(productsAvailableByScale);
    }, [
        customerHasChanged,
        hospitalExcess,
        JSON.stringify([
            extrasProducts,
            hospitalProducts,
            hospitalParentProductIds
        ]), 
    ]);
    (0,react.useEffect)(function() {
        actions.price.load(productIds, customer, {
            date: (0,get_future_date/* default */.Z)(useFutureEffectiveDate)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        customerHasChanged,
        hospitalExcess,
        useFutureEffectiveDate,
        JSON.stringify([
            extrasProducts,
            hospitalProducts
        ])
    ]);
    var selectedHospitalProductId = selectedProducts.hospital;
    var parentProductId = get_parent_product_id_default()(selectedHospitalProductId);
    (0,react.useEffect)(function() {
        if (!selectedHospitalProductId || !parentProductId) return;
        var excessHasUpdated = !(0,fp.includes)("-".concat(hospitalExcess), selectedHospitalProductId);
        if (!excessHasUpdated) return;
        var validHospitalProductIds = (0,fp.map)("id", products);
        var updatedHospitalProduct = "".concat(parentProductId, "-excess-").concat(hospitalExcess);
        var productToSetOrUnset = (0,fp.includes)(updatedHospitalProduct, validHospitalProductIds) ? updatedHospitalProduct : selectedHospitalProductId;
        dispatch(build_your_cover/* default.setOrUnsetSelectedProduct */.Z.setOrUnsetSelectedProduct("hospital", productToSetOrUnset));
    }, [
        hospitalExcess
    ]);
    (0,react.useEffect)(function() {
        if (!selectedHospitalProductId || !(0,fp.includes)(src.PARENT_PRODUCT.STARTER_BASIC, selectedHospitalProductId)) return;
        var selectedHospitalProduct = (0,fp.find)({
            id: selectedHospitalProductId
        }, products);
        var productIsAvailable = product/* default.isAvailableFor */.Z.isAvailableFor(selectedHospitalProduct, scale);
        if (!productIsAvailable) {
            dispatch(build_your_cover/* default.setOrUnsetSelectedProduct */.Z.setOrUnsetSelectedProduct(choose_your_cover_HOSPITAL, selectedHospitalProductId));
        }
    }, [
        scale
    ]);
    (0,react.useEffect)(function() {
        if (!(0,fp.isEmpty)(extrasProducts) && !(0,fp.isEmpty)(hospitalProducts)) {
            analytics/* default.ecommerceGA4 */.Z.ecommerceGA4(constants/* EVENTS.ECOMMERCE_GA4.VIEW_ITEM_LIST */.FP.ECOMMERCE_GA4.VIEW_ITEM_LIST, {
                customer: customer,
                products: (0,_to_consumable_array/* default */.Z)(hospitalProducts).concat((0,_to_consumable_array/* default */.Z)(extrasProducts))
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        stringedHospitalAndExtrasProducts
    ]);
    var handleScroll = function() {
        var ref, ref1, ref2, ref3;
        var ref4;
        var firstHospitalProduct = document.getElementById((ref4 = hospitalProducts === null || hospitalProducts === void 0 ? void 0 : (ref = hospitalProducts[0]) === null || ref === void 0 ? void 0 : ref.id) !== null && ref4 !== void 0 ? ref4 : "");
        var hospitalHeadTop = (ref1 = firstHospitalProduct === null || firstHospitalProduct === void 0 ? void 0 : firstHospitalProduct.getBoundingClientRect()) === null || ref1 === void 0 ? void 0 : ref1.top;
        var ref5;
        var firstExtrasProduct = document.getElementById((ref5 = extrasProducts === null || extrasProducts === void 0 ? void 0 : (ref2 = extrasProducts[0]) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref5 !== void 0 ? ref5 : "");
        var extrasHeadTop = (ref3 = firstExtrasProduct === null || firstExtrasProduct === void 0 ? void 0 : firstExtrasProduct.getBoundingClientRect()) === null || ref3 === void 0 ? void 0 : ref3.top;
        if (!(0,fp.isNil)(hospitalHeadTop) || !(0,fp.isNil)(extrasHeadTop)) {
            if (hospitalHeadTop === 0) {
                setCarouselStuck(choose_your_cover_HOSPITAL);
            } else if (extrasHeadTop === 0) {
                setCarouselStuck(EXTRAS);
            } else {
                setCarouselStuck(null);
            }
        }
    };
    (0,react.useEffect)(function() {
        if ("addEventListener" in windowService && (0,fp.isFunction)(windowService.addEventListener)) {
            windowService.addEventListener("scroll", handleScroll);
        }
        return function() {
            if ("removeEventListener" in windowService && (0,fp.isFunction)(windowService.removeEventListener)) {
                windowService.removeEventListener("scroll", handleScroll);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        productIds
    ]);
    var openChangeDetailsDrawer = (0,react.useCallback)(function() {
        drawer/* default.openDrawer */.Z.openDrawer(ui.DRAWER_IDS.CHANGE_DETAILS)(dispatch);
    }, [
        dispatch
    ]);
    if (hasError) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(redirect_adapter/* default */.Z, {
            to: url_constants.URLS.SALES.ERROR_500
        });
    }
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_spinner/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Wrapper */.im, {
                size: "large",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H1, {
                                looksLike: "h2",
                                children: "Choose the cover that suits you"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                variant: "withoutMargin",
                                children: "Here are options we think you’ll like based on the inclusions you chose"
                            }),
                            hasBestSellerWithFewerInclusions && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                children: "There’s also a best-seller that’s worth a look."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DisclaimerWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(price_disclaimer/* default */.ZP, {
                                bold: true,
                                elementType: "button",
                                forProducts: hospitalProducts,
                                highlightIncome: true,
                                showRefineLink: false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StyledButton, {
                                icon: {
                                    name: "pencil"
                                },
                                onClick: openChangeDetailsDrawer,
                                variant: [
                                    "border",
                                    "white",
                                    "smallPadding"
                                ],
                                children: "Edit"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(validation_alert, {
                        hospitalSectionRef: hospitalSectionRef,
                        extrasSectionRef: extrasSectionRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel_section, {
                        hasBestSellerWithFewerInclusions: hasHospitalBestSellerWithFewerInclusions,
                        productType: choose_your_cover_HOSPITAL,
                        products: hospitalProducts,
                        isStuck: carouselStuck === choose_your_cover_HOSPITAL,
                        sectionRef: hospitalSectionRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel_section, {
                        hasBestSellerWithFewerInclusions: hasExtrasBestSellerWithFewerInclusions,
                        productType: EXTRAS,
                        products: extrasProducts,
                        isStuck: carouselStuck === EXTRAS,
                        sectionRef: extrasSectionRef
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(step_footer_navigation, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_drawer/* default */.Z, {
                isProductWithHospitalServices: true,
                showIncomeOptions: true
            })
        ]
    });
};
var choose_your_cover_mapDispatchToProps = function(dispatch) {
    return {
        actions: {
            customer: (0,redux/* bindActionCreators */.DE)(customer/* default */.Z, dispatch),
            price: (0,redux/* bindActionCreators */.DE)(price/* default */.Z, dispatch)
        }
    };
};
var mapStateToProps = function(state) {
    return {
        customer: (0,select_customer/* default */.Z)(state),
        products: (0,select_products/* default */.Z)(state),
        selectedProducts: state.buildYourCover.selectedProducts,
        useFutureEffectiveDate: state.price.useFutureEffectiveDate
    };
};
/* harmony default export */ var choose_your_cover = ((0,es/* connect */.$j)(mapStateToProps, choose_your_cover_mapDispatchToProps)(ChooseYourCover));


// EXTERNAL MODULE: ./src/utils/head.tsx
var head = __webpack_require__(40985);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/components/price-bar/styles.ts

function price_bar_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 1rem 0;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n\n  @media (min-width: ",
        ") {\n    gap: 1rem;\n    flex-wrap: nowrap;\n    border: none;\n  }\n"
    ]);
    price_bar_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function price_bar_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  align-self: normal;\n  height: auto;\n  padding-left: 0.5rem;\n  border-left: 1px solid ",
        ";\n  flex-direction: column;\n\n  @media (min-width: ",
        ") {\n    padding-left: 1rem;\n  }\n"
    ]);
    price_bar_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function price_bar_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 0.5rem;\n\n  @media (min-width: ",
        ") {\n    gap: 1rem;\n    flex-direction: row;\n    border: none;\n  }\n"
    ]);
    price_bar_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function price_bar_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-basis: 100%;\n  width: 100%;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    flex-basis: unset;\n    width: unset;\n  }\n"
    ]);
    price_bar_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  min-width: 300px;\n  font-size: 1.25rem;\n  padding: 1rem;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 0.25rem;\n  color: ",
        ";\n  background-color: ",
        ";\n  transition-property: background-color, color;\n  transition-duration: 0.6s;\n  transition-timing-function: cubic-bezier(0.09, 0.94, 0.42, 0.98);\n  min-width: 250px;\n  gap: 1rem;\n  font-weight: ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding: 1rem;\n  }\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var PriceBarWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f0729672-0"
})(price_bar_styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.fontWeights.bold;
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var TotalPriceWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f0729672-1"
})(price_bar_styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.grey20;
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var SelectedProductsWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f0729672-2"
})(price_bar_styles_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var ButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f0729672-3"
})(price_bar_styles_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var price_bar_styles_StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-f0729672-4"
})(styles_templateObject4());
var ProductPriceWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f0729672-5"
})(styles_templateObject5(), function(param) {
    var theme = param.theme, isSelected = param.isSelected;
    return isSelected ? theme.colors.black : theme.colors.grey60;
}, function(param) {
    var theme = param.theme, isSelected = param.isSelected;
    return isSelected ? theme.colors.grey10 : theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.fontWeights.bold;
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
});


// EXTERNAL MODULE: ./node_modules/reselect/es/index.js
var reselect_es = __webpack_require__(22222);
// EXTERNAL MODULE: ./src/client/models/price/index.ts
var models_price = __webpack_require__(2798);
;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/components/price-bar/components/product-price-pill/index.tsx













var selectStateForComponent = function(productType, useFutureEffectiveDate) {
    return (0,reselect_es.createSelector)([
        select_customer/* default */.Z,
        select_prices/* default */.Z,
        select_products/* default */.Z,
        select_build_your_cover/* default */.Z
    ], function(customer, prices, products, param) {
        var selectedProducts = param.selectedProducts;
        var ref;
        var selectedProductId = selectedProducts[productType];
        if (!selectedProductId || !(products === null || products === void 0 ? void 0 : products[selectedProductId])) {
            return {
                selectedProductName: null,
                selectedProductPrice: null
            };
        }
        var date = (0,get_future_date/* default */.Z)(useFutureEffectiveDate);
        var _frequency;
        return {
            // Casting as getting a type error where `!products?.[selectedProductId]` isn't sufficient to enforce type
            selectedProductName: products[selectedProductId].name,
            selectedProductPrice: parseFloat((_frequency = (ref = models_price/* default.getPrice */.Z.getPrice(prices, selectedProductId, customer, {
                date: date
            })) === null || ref === void 0 ? void 0 : ref.amount[customer.frequency]) !== null && _frequency !== void 0 ? _frequency : "0")
        };
    });
};
var ProductPricePill = function(param) {
    var productType = param.productType;
    var useFutureEffectiveDate = (0,es/* useSelector */.v9)(function(state) {
        return state.price.useFutureEffectiveDate;
    });
    var ref = (0,es/* useSelector */.v9)(selectStateForComponent(productType, useFutureEffectiveDate), fp.isEqual), selectedProductName = ref.selectedProductName, selectedProductPrice = ref.selectedProductPrice;
    var isSelectedProduct = Boolean(selectedProductName);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPriceWrapper, {
        isSelected: isSelectedProduct,
        "data-testid": "product-price-pill-".concat(productType),
        children: selectedProductName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "aria-label": 'Selected "'.concat(selectedProductName, '" ').concat(productType, " cover"),
                    children: selectedProductName
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Price */.tA, {
                    price: selectedProductPrice ? models_price/* default.getPriceAsObject */.Z.getPriceAsObject(selectedProductPrice) : null,
                    showAsterisk: true,
                    variant: [
                        "compact",
                        "inlineSpinner"
                    ],
                    withoutFrequency: true
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            "aria-label": "No ".concat(productType, " cover selected"),
            children: [
                (0,fp.startCase)(productType),
                " cover: —"
            ]
        })
    });
};
/* harmony default export */ var product_price_pill = (ProductPricePill);

// EXTERNAL MODULE: ./src/client/selectors/select-effective-date-override/index.ts
var select_effective_date_override = __webpack_require__(89298);
;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/components/price-bar/components/product-price-total/index.tsx












var product_price_total_selectStateForComponent = (0,reselect_es.createSelector)([
    select_customer/* default */.Z,
    select_effective_date_override/* default */.Z,
    select_prices/* default */.Z,
    select_build_your_cover/* default */.Z
], function(customer, effectiveDateOverride, prices, param) {
    var selectedProducts = param.selectedProducts;
    var selectedProductIds = (0,fp.reject)(fp.isNull, selectedProducts);
    var date = (0,get_future_date/* default */.Z)(effectiveDateOverride);
    var allPrices = (0,fp.compact)(models_price/* default.getPrices */.Z.getPrices(prices, selectedProductIds, customer, {
        date: date
    }));
    return {
        frequency: customer.frequency,
        isLoading: allPrices.length !== selectedProductIds.length,
        selectedTotalProductPrice: allPrices.length > 0 ? (0,fp.flow)(// @ts-expect-error [🤖 PLEASE FIX 🤖]: Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        (0,fp.map)(function(priceData) {
            var ref;
            return parseFloat((ref = priceData.amount) === null || ref === void 0 ? void 0 : ref[customer.frequency]);
        }), fp.sum)(allPrices) : null
    };
});
var ProductPriceTotal = function() {
    var ref = (0,es/* useSelector */.v9)(product_price_total_selectStateForComponent, fp.isEqual), frequency = ref.frequency, isLoading = ref.isLoading, selectedTotalProductPrice = ref.selectedTotalProductPrice;
    if (selectedTotalProductPrice) {
        var totalPriceForPriceComponent = models_price/* default.getPriceAsObject */.Z.getPriceAsObject(selectedTotalProductPrice);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                    xs: true,
                    sm: true,
                    md: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Price */.tA, {
                        frequency: frequency,
                        price: totalPriceForPriceComponent,
                        showAsterisk: true,
                        showFrom: true,
                        isFrequencyInline: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                    lg: true,
                    df: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Price */.tA, {
                        frequency: frequency,
                        price: totalPriceForPriceComponent,
                        showAsterisk: true,
                        showFrom: true
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Price */.tA, {
        frequency: frequency,
        price: isLoading ? null : {
            cents: "--",
            dollars: "--"
        },
        showAsterisk: true,
        showFrom: true
    });
};
/* harmony default export */ var product_price_total = (ProductPriceTotal);

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/components/price-bar/index.tsx











var ReviewCoverButton = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var selectedProducts = (0,es/* useSelector */.v9)(select_build_your_cover/* default */.Z).selectedProducts;
    var onReviewCoverClick = function() {
        build_your_cover/* default.submitReview */.Z.submitReview(selectedProducts, router)(dispatch);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(price_bar_styles_StyledButton, {
        onClick: onReviewCoverClick,
        variant: [
            "purple",
            "wide"
        ],
        children: "Review cover"
    });
};
var PriceBar = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Wrapper */.im, {
        size: "large",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceBarWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectedProductsWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(product_price_pill, {
                            productType: graphql/* ProductType.Hospital */.kv.Hospital
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(product_price_pill, {
                            productType: graphql/* ProductType.Extras */.kv.Extras
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalPriceWrapper, {
                    "data-testid": "build-your-own-total-price",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_price_total, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewCoverButton, {})
                })
            ]
        })
    });
};
/* harmony default export */ var price_bar = (PriceBar);

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/steps/components/service-selection/index.tsx

function service_selection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: left;\n\n  @media (min-width: ",
        ") {\n    width: fit-content;\n  }\n"
    ]);
    service_selection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function service_selection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 2.5rem 0;\n"
    ]);
    service_selection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var AlertSection = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a952ba74-0"
})(service_selection_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var service_selection_StyledClickable = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-a952ba74-1"
})(service_selection_templateObject1());
var initialViewCount = 10;
var revealCount = 10;
var ServiceSelection = function(param) {
    var selectedServices = param.selectedServices, serviceList = param.serviceList, setSelectedServices = param.setSelectedServices, subtitle = param.subtitle, title = param.title;
    var ref = (0,ahm_ui/* useStepperContext */.sF)(), activeStep = ref.activeStep, goToNextStep = ref.goToNextStep;
    var ref1 = (0,react.useState)(selectedServices), selections = ref1[0], setSelections = ref1[1];
    var selectedProducts = (0,es/* useSelector */.v9)(select_build_your_cover/* default */.Z).selectedProducts;
    var ref2 = (0,react.useState)(initialViewCount), toView = ref2[0], setToView = ref2[1];
    var ref3 = (0,react.useState)(Boolean(selectedProducts.hospital) || Boolean(selectedProducts.extras)), showAlert = ref3[0], setShowAlert = ref3[1];
    (0,react.useEffect)(function() {
        setShowAlert(Boolean(selectedProducts.hospital) || Boolean(selectedProducts.extras));
    }, [
        selectedProducts
    ]);
    var handleCloseAlert = function() {
        return setShowAlert(false);
    };
    var toggleSelection = function(service) {
        if ((0,fp.includes)(service, selections)) {
            setSelections((0,fp.remove)(function(selection) {
                return selection === service;
            }, selections));
        } else {
            setSelections((0,fp.concat)([
                service
            ], selections));
        }
    };
    var viewMore = function() {
        setToView(Math.min(toView + revealCount, serviceList.length));
    };
    var backToTop = function() {
        (0,utils_ui/* scrollTo */.X5)(0);
    };
    var handleOnNextClick = function() {
        setSelectedServices(selections);
        goToNextStep();
    };
    var items = (0,fp.map)(function(service) {
        return {
            analytics: {
                label: "Selected ".concat(analyticsLabels[activeStep], " service")
            },
            label: service.name,
            tooltipContent: service.description,
            value: service.serviceId
        };
    }, serviceList);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Wrapper */.im, {
                size: "medium",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* TypeWrapper */.f3, {
                    variant: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H1, {
                            looksLike: "h2",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                            variant: "paddingBottomSpacer8",
                            children: subtitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertSection, {
                            children: showAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Alert */.bZ, {
                                heading: "Your cover may change",
                                analyticsLabel: "Cover may change",
                                level: "info",
                                onClose: handleCloseAlert,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                    children: "Updating your hospital or extras services may remove some of your previously selected cover."
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* CheckboxGrid */.I6, {
                            checkedValues: selections,
                            items: items.slice(0, toView),
                            onChange: toggleSelection
                        }),
                        toView < serviceList.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(service_selection_StyledClickable, {
                            onClick: viewMore,
                            variant: "button",
                            icon: {
                                name: "chevron-down",
                                position: "right"
                            },
                            children: "View more"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(service_selection_StyledClickable, {
                            onClick: backToTop,
                            variant: "button",
                            icon: {
                                name: "chevron-up",
                                position: "right"
                            },
                            children: "Back to top"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(step_footer_navigation, {
                onNextClick: handleOnNextClick
            })
        ]
    });
};
/* harmony default export */ var service_selection = (ServiceSelection);

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/steps/service-selection-with-data-loader/index.tsx



function service_selection_with_data_loader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GetServices($input: ServiceInput) {\n    getServices(input: $input) {\n      description\n      name\n      serviceId\n    }\n  }\n"
    ]);
    service_selection_with_data_loader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var GET_SERVICES = (0,core.gql)(service_selection_with_data_loader_templateObject());
var headings = {
    extras: {
        subtitle: "See our commonly chosen inclusions below or view the whole list.",
        title: "Extras"
    },
    hospital: {
        subtitle: "See our commonly chosen inclusions below or view the whole list.",
        title: "Hospital"
    }
};
var ServiceSelectionWithDataLoader = function(param) {
    var productType = param.productType;
    var ref, ref1;
    var dispatch = (0,es/* useDispatch */.I0)();
    var selectedServicesFromState = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1;
        return (ref = (0,select_build_your_cover/* default */.Z)(state)) === null || ref === void 0 ? void 0 : (ref1 = ref.selectedServices) === null || ref1 === void 0 ? void 0 : ref1[productType];
    });
    var dob = (ref1 = (ref = (0,es/* useSelector */.v9)(select_customer/* default */.Z)) === null || ref === void 0 ? void 0 : ref.members[0]) === null || ref1 === void 0 ? void 0 : ref1.dob;
    var setSelectedServices = function(selectedServices) {
        build_your_cover/* default.setSelectedServices */.Z.setSelectedServices(productType, selectedServices)(dispatch);
    };
    var ref2 = (0,client.useQuery)(GET_SERVICES, {
        client: graphql_client/* default */.Z,
        variables: {
            input: {
                dob: dob,
                productType: productType
            }
        }
    }), data = ref2.data, loading = ref2.loading;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_spinner/* default */.Z, {});
    }
    if (!data) {
        throw new Error("No data returned from GetServices query");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(service_selection, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, headings[productType]), {
        selectedServices: selectedServicesFromState,
        serviceList: data.getServices,
        setSelectedServices: setSelectedServices
    }));
};
/* harmony default export */ var service_selection_with_data_loader = (ServiceSelectionWithDataLoader);

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/components/step-header-navigation/styles.ts

function step_header_navigation_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  margin-bottom: 4rem;\n"
    ]);
    step_header_navigation_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function step_header_navigation_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 0px 0px 40px 40px;\n  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.06);\n  display: flex;\n  justify-content: center;\n  height: 3.5rem;\n  padding: 1rem 2rem 1rem 2rem;\n  width: ",
        ";\n\n  ",
        "\n"
    ]);
    step_header_navigation_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function step_header_navigation_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  &:not(:last-child) {\n    padding-right: 2rem;\n  }\n\n  ",
        "\n"
    ]);
    step_header_navigation_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function step_header_navigation_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 50%;\n  display: inline-block;\n  color: ",
        ";\n  font-size: 0.75rem;\n  font-weight: 800;\n  height: 28px;\n  padding-top: 4px;\n  text-align: center;\n  width: 28px;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    step_header_navigation_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function step_header_navigation_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  padding-left: 1rem;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    step_header_navigation_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function step_header_navigation_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    step_header_navigation_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var StepsWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c4d653b7-0"
})(step_header_navigation_styles_templateObject());
var InnerWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c4d653b7-1"
})(step_header_navigation_styles_templateObject1(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "calc(100vw - 2rem)" : "50rem";
}, function(param) {
    var isMobileNavExpanded = param.isMobileNavExpanded;
    return isMobileNavExpanded && "\n      border-radius: 0;\n      box-shadow: none;\n    ";
});
var StepWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c4d653b7-2"
})(step_header_navigation_styles_templateObject2(), function(param) {
    var isMobile = param.isMobile;
    return isMobile && "\n      padding-bottom: 1rem;\n      padding-left: 1rem;\n      padding-top: 1rem;\n    ";
});
var StepNumber = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c4d653b7-3"
})(step_header_navigation_styles_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.grey10;
}, function(param) {
    var theme = param.theme;
    return theme.colors.grey50;
}, function(param) {
    var $isActive = param.$isActive, theme = param.theme;
    return $isActive && "\n      background-color: ".concat(theme.colors.black, ";\n      color:").concat(theme.colors.white, ";\n    ");
}, function(param) {
    var $isBeforeActiveStep = param.$isBeforeActiveStep, theme = param.theme;
    return $isBeforeActiveStep && "\n      background-color: ".concat(theme.colors.black, ";\n      color: ").concat(theme.colors.white, ";\n\n      >svg {\n        fill: ").concat(theme.colors.white, ";\n        position: relative;\n        top: 3px;\n      }\n    ");
});
var StepName = (0,styled_components_browser_esm["default"])(ahm_ui/* Span */.Dr).withConfig({
    componentId: "sc-c4d653b7-4"
})(step_header_navigation_styles_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.grey50;
}, function(param) {
    var $isActive = param.$isActive, theme = param.theme;
    return $isActive && "\n      color:".concat(theme.colors.black, ";\n    ");
}, function(param) {
    var $isBeforeActiveStep = param.$isBeforeActiveStep, theme = param.theme;
    return $isBeforeActiveStep && "\n      color:".concat(theme.colors.black, ";\n    ");
});
var styles_StyledClickable = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-c4d653b7-5"
})(step_header_navigation_styles_templateObject5());

// EXTERNAL MODULE: ./node_modules/@ahmdigital/icons-web/lib/index.js
var lib = __webpack_require__(54312);
// EXTERNAL MODULE: ./src/utils/uncap-fp-iterator.ts
var uncap_fp_iterator = __webpack_require__(96852);
;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/hooks/use-active-index/index.ts

var useActiveIndex = function() {
    var ref = (0,ahm_ui/* useStepperContext */.sF)(), activeStep = ref.activeStep, steps = ref.steps;
    var activeIndex = steps.indexOf(activeStep);
    return activeIndex;
};
/* harmony default export */ var use_active_index = (useActiveIndex);

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/components/step-header-navigation/navigation-steps/index.tsx








var mapWithIndex = (0,uncap_fp_iterator/* default */.Z)(fp.map);
var StepNavigation = function(param) {
    var _hasStepZero = param.hasStepZero, hasStepZero = _hasStepZero === void 0 ? false : _hasStepZero, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, handleGoToStep = param.handleGoToStep;
    var ref = (0,ahm_ui/* useStepperContext */.sF)(), activeStep = ref.activeStep, steps = ref.steps;
    var activeIndex = use_active_index();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: mapWithIndex(function(step, index) {
            var isActive = activeStep === step;
            var isBeforeActiveStep = index < activeIndex;
            var isAfterActiveStep = index > activeIndex;
            if (hasStepZero && step === steps[0]) {
                return null;
            }
            var stepNumber = hasStepZero ? index : index + 1;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepWrapper, {
                isMobile: isMobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_StyledClickable, {
                    disabled: isAfterActiveStep,
                    isUnstyled: true,
                    onClick: function() {
                        return handleGoToStep(step);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StepNumber, {
                            $isActive: isActive,
                            $isBeforeActiveStep: isBeforeActiveStep,
                            children: isBeforeActiveStep ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lib["default"], {
                                name: "tick",
                                width: 12,
                                height: 12
                            }) : stepNumber
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StepName, {
                            $isActive: isActive,
                            $isBeforeActiveStep: isBeforeActiveStep,
                            children: step
                        })
                    ]
                })
            }, step);
        }, steps)
    });
};
/* harmony default export */ var navigation_steps = (StepNavigation);

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/components/step-header-navigation/desktop-navigation/index.tsx




var DesktopNavigation = function(param) {
    var handleGoToStep = param.handleGoToStep, _hasStepZero = param.hasStepZero, hasStepZero = _hasStepZero === void 0 ? false : _hasStepZero;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_steps, {
            hasStepZero: hasStepZero,
            handleGoToStep: handleGoToStep
        })
    });
};
/* harmony default export */ var desktop_navigation = (DesktopNavigation);

// EXTERNAL MODULE: ./src/client/components/animate/index.tsx
var animate = __webpack_require__(1743);
;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/components/step-header-navigation/mobile-expanded-navigation/index.tsx

function mobile_expanded_navigation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-top: 1px solid ",
        ";\n  box-shadow: 0px 4px 7px 0px rgba(128, 128, 128, 0.3);\n  padding-bottom: 1.5rem;\n  position: absolute;\n  top: 3.5rem;\n  width: 100%;\n  z-index: ",
        ";\n"
    ]);
    mobile_expanded_navigation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var VerticalStepsWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f680df00-0"
})(mobile_expanded_navigation_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.grey10;
}, function(param) {
    var theme = param.theme;
    return theme.zIndices.modal;
});
var MobileExpandedNavigation = function(param) {
    var handleGoToStep = param.handleGoToStep, _hasStepZero = param.hasStepZero, hasStepZero = _hasStepZero === void 0 ? false : _hasStepZero;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(animate/* default */.Z, {
        name: "slideIn",
        appear: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalStepsWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_steps, {
                hasStepZero: hasStepZero,
                isMobile: true,
                handleGoToStep: handleGoToStep
            })
        })
    });
};
/* harmony default export */ var mobile_expanded_navigation = (MobileExpandedNavigation);

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/components/step-header-navigation/mobile-navigation/index.tsx

function mobile_navigation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 0.5rem;\n"
    ]);
    mobile_navigation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function mobile_navigation_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    mobile_navigation_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var StyledStepName = (0,styled_components_browser_esm["default"])(ahm_ui/* Span */.Dr).withConfig({
    componentId: "sc-de4590f8-0"
})(mobile_navigation_templateObject());
var StyledDiv = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-de4590f8-1"
})(mobile_navigation_templateObject1());
var MobileNavigation = function(param) {
    var _hasStepZero = param.hasStepZero, hasStepZero = _hasStepZero === void 0 ? false : _hasStepZero, isMobileNavExpanded = param.isMobileNavExpanded, setIsMobileNavExpanded = param.setIsMobileNavExpanded;
    var ref = (0,ahm_ui/* useStepperContext */.sF)(), activeStep = ref.activeStep, steps = ref.steps;
    var activeIndex = use_active_index();
    var totalSteps = hasStepZero ? steps.length - 1 : steps.length;
    var currentStep = hasStepZero ? activeIndex : activeIndex + 1;
    var handleStepsToggle = function() {
        setIsMobileNavExpanded(!isMobileNavExpanded);
    };
    var chevronName = isMobileNavExpanded ? "app-chevron-up" : "app-chevron-down";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDiv, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerWrapper, {
            isMobile: true,
            isMobileNavExpanded: isMobileNavExpanded,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Clickable */.P3, {
                onClick: handleStepsToggle,
                isUnstyled: true,
                icon: {
                    name: chevronName,
                    position: "right"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Strong */.cK, {
                        children: [
                            "Step ",
                            currentStep,
                            " of ",
                            totalSteps,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStepName, {
                        children: activeStep
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var mobile_navigation = (MobileNavigation);

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/components/step-header-navigation/index.tsx

function step_header_navigation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    step_header_navigation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var step_header_navigation_StyledDiv = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-2c3c23ee-0"
})(step_header_navigation_templateObject());
var StepHeaderNavigation = function(param) {
    var _hasStepZero = param.hasStepZero, hasStepZero = _hasStepZero === void 0 ? false : _hasStepZero;
    var ref = (0,react.useState)(false), isMobileNavExpanded = ref[0], setIsMobileNavExpanded = ref[1];
    var ref1 = (0,ahm_ui/* useStepperContext */.sF)(), activeStep = ref1.activeStep, goToStep = ref1.goToStep;
    var dispatch = (0,es/* useDispatch */.I0)();
    var activeIndex = use_active_index();
    var hideForStepZero = hasStepZero && activeIndex === 0;
    var isFromRefinePrice = (0,es/* useSelector */.v9)(function(state) {
        return state.history[1];
    }) === ahm_constants/* default.URLS.SALES.REFINE_PRICE */.Z.URLS.SALES.REFINE_PRICE;
    var hasRefinedPrice = (0,es/* useSelector */.v9)(select_customer/* default */.Z).hasRefinedPrice;
    (0,react.useEffect)(function() {
        setIsMobileNavExpanded(false);
        window.scrollTo(0, 0);
    }, [
        activeStep
    ]);
    (0,react.useEffect)(function() {
        if (isFromRefinePrice && hasRefinedPrice && (0,fp.includes)(activeStep, [
            STEPS.SPLASH_SCREEN,
            STEPS.ABOUT_YOU
        ])) {
            goToStep(STEPS.HOSPITAL_SERVICES);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFromRefinePrice
    ]);
    (0,react.useEffect)(function() {
        build_your_cover/* default.setActiveStep */.Z.setActiveStep(activeStep)(dispatch);
    }, [
        activeStep,
        dispatch
    ]);
    var handleGoToStep = function(step) {
        setIsMobileNavExpanded(false);
        build_your_cover/* default.setActiveStep */.Z.setActiveStep(step)(dispatch);
        goToStep(step);
    };
    if (hideForStepZero) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(step_header_navigation_StyledDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepsWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                        isBlock: true,
                        xs: true,
                        sm: true,
                        md: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_navigation, {
                            handleGoToStep: handleGoToStep,
                            hasStepZero: hasStepZero
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                        isBlock: true,
                        lg: true,
                        xl: true,
                        df: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_navigation, {
                            hasStepZero: hasStepZero,
                            isMobileNavExpanded: isMobileNavExpanded,
                            setIsMobileNavExpanded: setIsMobileNavExpanded
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                isBlock: true,
                lg: true,
                xl: true,
                df: true,
                children: isMobileNavExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_expanded_navigation, {
                    handleGoToStep: handleGoToStep,
                    hasStepZero: hasStepZero
                })
            })
        ]
    });
};
/* harmony default export */ var step_header_navigation = (StepHeaderNavigation);

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/steps/welcome/styles.ts

function welcome_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1.5rem;\n  min-width: 20rem;\n  @media (min-width: ",
        ") {\n    margin-top: 7rem;\n  }\n"
    ]);
    welcome_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function welcome_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 2rem;\n  @media (min-width: ",
        ") {\n    margin-bottom: 5.5rem;\n  }\n"
    ]);
    welcome_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function welcome_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 1rem;\n  padding-right: 1rem;\n  text-align: center;\n"
    ]);
    welcome_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function welcome_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: '0 auto';\n  max-width: '31.25rem';\n"
    ]);
    welcome_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var welcome_styles_StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-9cce7174-0"
})(welcome_styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var StyledP = (0,styled_components_browser_esm["default"])(ahm_ui.P).withConfig({
    componentId: "sc-9cce7174-1"
})(welcome_styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var styles_StyledSection = (0,styled_components_browser_esm["default"])(ahm_ui/* Section */.$0).withConfig({
    componentId: "sc-9cce7174-2"
})(welcome_styles_templateObject2());
var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9cce7174-3"
})(welcome_styles_templateObject3());

// EXTERNAL MODULE: ./src/client/components/step-list/index.tsx + 1 modules
var step_list = __webpack_require__(57467);
;// CONCATENATED MODULE: ./public/assets/img/welcome-mat.svg
/* harmony default export */ var welcome_mat = ({"src":"/_next/static/media/welcome-mat.b06ccf11.svg","height":173,"width":460});
;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/steps/welcome/index.tsx






var WELCOME_STEPS = [
    "Let’s get to know you.",
    "Pick the services you actually want to include.",
    "Choose the cover for you.", 
];
var Welcome = function() {
    var goToNextStep = (0,ahm_ui/* useStepperContext */.sF)().goToNextStep;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_StyledSection, {
        variant: "large",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H1, {
                looksLike: "h2",
                children: "Choose your own hospital & extras"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledP, {
                children: "Get hospital & extras cover based on what’s important to you in a matter of minutes."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* AxisSwitcher */.e$, {
                limit: 2,
                threshold: "61rem",
                space: "1rem",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* SpacerWrapper */.Cj, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(step_list/* default */.Z, {
                            isVertical: true,
                            steps: WELCOME_STEPS
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                            src: welcome_mat.src,
                            width: "100%",
                            role: "presentation"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(welcome_styles_StyledButton, {
                onClick: goToNextStep,
                children: "Let’s go"
            })
        ]
    });
};
/* harmony default export */ var welcome = (Welcome);

;// CONCATENATED MODULE: ./src/client/pages/build-your-cover/index.tsx


function build_your_cover_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-top: 1px solid ",
        ";\n  box-shadow: 0px -7px 20px 0px rgba(0, 0, 0, 0.15);\n  margin-top: -0.5rem;\n  bottom: -0.5rem;\n  position: sticky;\n  z-index: ",
        ";\n\n  @media (min-width: ",
        ") {\n    border: none;\n  }\n"
    ]);
    build_your_cover_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

















var steps = [
    STEPS.ABOUT_YOU,
    STEPS.HOSPITAL_SERVICES,
    STEPS.EXTRAS_SERVICES,
    STEPS.CHOOSE_THE_COVER
];
var Footer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-819e52f9-0"
})(build_your_cover_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.grey30;
}, function(param) {
    var theme = param.theme;
    return theme.zIndices.footer;
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var BuildYourCover = function() {
    var activeStep = (0,es/* useSelector */.v9)(select_build_your_cover/* default */.Z).activeStep;
    var hasRefinedPrice = (0,es/* useSelector */.v9)(select_customer/* default */.Z).hasRefinedPrice;
    var isFromRefinePrice = (0,es/* useSelector */.v9)(function(state) {
        return state.history[1];
    }) === ahm_constants/* default.URLS.SALES.REFINE_PRICE */.Z.URLS.SALES.REFINE_PRICE;
    var skipSplashScreen = isFromRefinePrice && hasRefinedPrice;
    var updatedSteps = skipSplashScreen ? steps : [
        STEPS.SPLASH_SCREEN
    ].concat((0,_to_consumable_array/* default */.Z)(steps));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Choose your own cover"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex, nofollow"
                    }, "robots")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* BorderGridContainer */.sO, {
                hideBorderTop: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* GridBox */.zc, {
                        padding: "0 0 1rem 0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* TypeWrapper */.f3, {
                            variant: "marginBottomSpacer6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Stepper */.vF, {
                                initialStep: activeStep,
                                steps: updatedSteps,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(step_header_navigation, {
                                        hasStepZero: !skipSplashScreen
                                    }),
                                    !skipSplashScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Step */.h8, {
                                        name: STEPS.SPLASH_SCREEN,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(welcome, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Step */.h8, {
                                        name: STEPS.ABOUT_YOU,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(about_you, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Step */.h8, {
                                        name: STEPS.HOSPITAL_SERVICES,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(service_selection_with_data_loader, {
                                            productType: graphql/* ProductType.Hospital */.kv.Hospital
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Step */.h8, {
                                        name: STEPS.EXTRAS_SERVICES,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(service_selection_with_data_loader, {
                                            productType: graphql/* ProductType.Extras */.kv.Extras
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Step */.h8, {
                                        name: STEPS.CHOOSE_THE_COVER,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(choose_your_cover, {})
                                    })
                                ]
                            })
                        })
                    }),
                    activeStep === STEPS.CHOOSE_THE_COVER && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(price_bar, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_build_your_cover = (BuildYourCover);

;// CONCATENATED MODULE: ./pages/health-insurance/choose-your-cover/index.page.tsx

/* harmony default export */ var index_page = (pages_build_your_cover);


/***/ }),

/***/ 78937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _action_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23094);
/* harmony import */ var _pages_product_util_use_is_from_choose_your_cover__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96901);
/* harmony import */ var _types_codegen_ahm_api_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7473);
/* harmony import */ var _models_product__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43735);
/* harmony import */ var _models_url__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26789);






var validateSelectedProducts = function(selectedProducts) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.flow)((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.pickBy)(lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isNull), lodash_fp__WEBPACK_IMPORTED_MODULE_0__.keys)(selectedProducts);
};
var setSelectedServices = function(productType, selectedServices) {
    return function(dispatch) {
        return dispatch({
            productType: productType,
            selectedServices: selectedServices,
            type: _action_types__WEBPACK_IMPORTED_MODULE_5__/* .BUILD_YOUR_COVER_SERVICES_CHANGE */ .Nz
        });
    };
};
var setOrUnsetSelectedProduct = function(productType, selectedProductId) {
    return function(dispatch, getState) {
        var ref = getState(), selectedProducts = ref.buildYourCover.selectedProducts;
        // If the product is already selected, deselect it
        if (selectedProducts[productType] === selectedProductId) {
            dispatch({
                productType: productType,
                selectedProductId: selectedProductId,
                type: _action_types__WEBPACK_IMPORTED_MODULE_5__/* .BUILD_YOUR_COVER_RESET_PRODUCT */ .c0
            });
        } else {
            dispatch({
                productType: productType,
                selectedProductId: selectedProductId,
                type: _action_types__WEBPACK_IMPORTED_MODULE_5__/* .BUILD_YOUR_COVER_SELECT_PRODUCT */ .ql
            });
            var newInvalidProductTypes = validateSelectedProducts(selectedProducts);
            dispatch({
                newInvalidProductTypes: newInvalidProductTypes,
                type: _action_types__WEBPACK_IMPORTED_MODULE_5__/* .BUILD_YOUR_COVER_INVALID_PRODUCT_TYPES */ .Ro
            });
        }
    };
};
var submitReview = function(selectedProducts, router) {
    return function(dispatch) {
        // Validate that all product types are selected and set/clear invalid product types
        var invalidProductTypes = validateSelectedProducts(selectedProducts);
        dispatch({
            invalidProductTypes: invalidProductTypes,
            type: _action_types__WEBPACK_IMPORTED_MODULE_5__/* .BUILD_YOUR_COVER_INVALID_PRODUCT_TYPES */ .Ro
        });
        // Go to the combined product page
        if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(invalidProductTypes)) {
            var cartProductId = _models_product__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getCombinedId */ .Z.getCombinedId({
                id: selectedProducts.hospital,
                type: _types_codegen_ahm_api_graphql__WEBPACK_IMPORTED_MODULE_2__/* .ProductType.Hospital */ .kv.Hospital
            }, {
                id: selectedProducts.extras,
                type: _types_codegen_ahm_api_graphql__WEBPACK_IMPORTED_MODULE_2__/* .ProductType.Extras */ .kv.Extras
            });
            var productUrl = "".concat(_models_url__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getProductUrl */ .Z.getProductUrl(cartProductId), "?").concat(_pages_product_util_use_is_from_choose_your_cover__WEBPACK_IMPORTED_MODULE_1__/* .IS_CHOOSE_YOUR_COVER */ .Z, "=true");
            router.push(productUrl);
        }
    };
};
var setActiveStep = function(activeStep) {
    return function(dispatch) {
        return dispatch({
            activeStep: activeStep,
            type: _action_types__WEBPACK_IMPORTED_MODULE_5__/* .BUILD_YOUR_COVER_STEP_CHANGE */ .Em
        });
    };
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    setActiveStep: setActiveStep,
    setOrUnsetSelectedProduct: setOrUnsetSelectedProduct,
    setSelectedServices: setSelectedServices,
    submitReview: submitReview
});


/***/ }),

/***/ 15311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _action_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23094);
/* harmony import */ var _models_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43735);



/**
 * Load products into state.
 *
 * @param {string|string[]} productIds - One or a list of product ids.
 * @returns {object} Action.
 */ // @ts-expect-error - Automatic, Please fix when editing this file
function load(productIds) {
    var array = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isString)(productIds) ? [
        productIds
    ] : productIds;
    return {
        productIds: array,
        // @ts-expect-error - Automatic, Please fix when editing this file
        promise: function(api) {
            return _models_product__WEBPACK_IMPORTED_MODULE_1__/* ["default"].loadProducts */ .Z.loadProducts(api, array);
        },
        types: [
            _action_types__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_LOAD */ .F9,
            _action_types__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_LOAD_SUCCESS */ .cx,
            _action_types__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_LOAD_FAIL */ .w2
        ]
    };
}
/* harmony default export */ __webpack_exports__["Z"] = ({
    load: load
});


/***/ }),

/***/ 30950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90937);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_3__);




/**
 * @deprecated If you need to display a transition state for the entire content of a page please
 * prefer LoadingContent to avoid breaking accessibility rules.
 */ var LoadingSpinner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_3___default().section),
        "data-testid": "loading-spinner",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Section */ .$0, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Wrapper */ .im, {
                size: "large",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Spinner */ .$j, {})
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingSpinner);


/***/ }),

/***/ 57467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ step_list; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/client/components/step-list/images/ellipse.svg
var ellipse = __webpack_require__(72898);
;// CONCATENATED MODULE: ./src/client/components/step-list/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  counter-reset: list-counter;\n  display: ",
        ";\n  flex-direction: column;\n  gap: 1rem;\n  justify-content: center;\n  list-style: none;\n  margin-bottom: 1rem;\n  text-align: left;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    gap: 2rem;\n    margin-bottom: 3rem;\n  }\n\n  li {\n    align-items: baseline;\n    gap: ",
        ";\n    counter-increment: list-counter;\n    display: flex;\n    flex-direction: row;\n    width: ",
        ";\n\n    :not(:last-child) {\n      ",
        ";\n    }\n\n    @media (min-width: ",
        ") {\n      width: auto;\n    }\n\n    ::before {\n      background: url('",
        "') no-repeat center center;\n      border-radius: 50%;\n      color: ",
        ";\n      content: counter(list-counter);\n      display: flex;\n      flex-shrink: 0;\n      font-family: ",
        ";\n      font-weight: bold;\n      height: 1.5rem;\n      justify-content: center;\n      margin-right: 0.5rem;\n      width: 1.5rem;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



// eslint-disable-next-line import/prefer-default-export
var StyledList = (0,styled_components_browser_esm["default"])(ahm_ui/* List */.aV).withConfig({
    componentId: "sc-79fb64ad-0"
})(_templateObject(), function(param) {
    var isVertical = param.isVertical;
    return isVertical ? "inline-block" : "flex";
}, function(param) {
    var theme = param.theme;
    return theme.media.sm;
}, function(param) {
    var isVertical = param.isVertical;
    return isVertical ? "0.5rem" : "0";
}, function(param) {
    var isVertical = param.isVertical;
    return isVertical ? "auto" : "15rem";
}, function(param) {
    var isVertical = param.isVertical;
    return isVertical && "margin-bottom: 1.5rem";
}, function(param) {
    var theme = param.theme;
    return theme.media.sm;
}, ellipse/* default.src */.Z.src, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.fontFamilies.secondary;
});

;// CONCATENATED MODULE: ./src/client/components/step-list/index.tsx




var StepList = function(param) {
    var _isVertical = param.isVertical, isVertical = _isVertical === void 0 ? false : _isVertical, steps = param.steps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledList, {
        isVertical: isVertical,
        children: (0,fp.map)(function(step) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: step
            }, step);
        }, steps)
    });
};
/* harmony default export */ var step_list = (StepList);


/***/ }),

/***/ 1565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_has_hospital_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97279);


var getUnavailableProductProps = function(changeExcessFunction, hospitalExcess, product) {
    var ref, ref1;
    var DEFAULT_EXCESS = "750";
    var RADIX = 10;
    var customerExcess = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.parseInt)(RADIX, hospitalExcess);
    var productExcess = product === null || product === void 0 ? void 0 : (ref = product.charges) === null || ref === void 0 ? void 0 : (ref1 = ref.excess) === null || ref1 === void 0 ? void 0 : ref1.amount;
    var isUnavailableProduct = (0,_utils_has_hospital_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(product) && customerExcess !== productExcess;
    return isUnavailableProduct ? {
        changeExcess: function() {
            return changeExcessFunction(DEFAULT_EXCESS);
        },
        changeTo: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.parseInt)(RADIX, DEFAULT_EXCESS),
        current: customerExcess
    } : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (getUnavailableProductProps);


/***/ }),

/***/ 34237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);

var truncateFrequency = function(frequency) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.replace)("ly", "", frequency);
};
/* harmony default export */ __webpack_exports__["Z"] = (truncateFrequency);


/***/ }),

/***/ 11857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ StyledListbox; },
/* harmony export */   "v": function() { return /* binding */ PriceWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n  font-size: 0.875rem;\n\n  button {\n    padding: 0.75rem 0;\n    border-radius: 1px;\n  }\n  p {\n    font-size: 0.875rem;\n    line-height: 1.125rem;\n    margin-bottom: 0;\n  }\n  svg {\n    width: 1.5rem;\n    height: 1.5rem;\n    margin-left: 0.5rem;\n    vertical-align: middle;\n  }\n  ul {\n    min-width: auto;\n  }\n\n  label {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n\n  div[role='combobox'] {\n    ul {\n      width: fit-content;\n      left: 0;\n      right: 0;\n      margin-left: auto;\n      margin-right: auto;\n      margin-top: 0;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledListbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Listbox */ .Ri).withConfig({
    componentId: "sc-d3d0b71c-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.fontWeights.bold;
});
var PriceWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-d3d0b71c-1"
})(_templateObject1());


/***/ }),

/***/ 96901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IS_CHOOSE_YOUR_COVER; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

var IS_CHOOSE_YOUR_COVER = "isChooseYourCover";
var useIsFromChooseYourCover = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    return Boolean(router.query[IS_CHOOSE_YOUR_COVER]);
};
/* harmony default export */ __webpack_exports__["C"] = (useIsFromChooseYourCover);


/***/ }),

/***/ 4251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ refine_price_form_fields; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/components/customer-form/components/age-field/index.tsx
var age_field = __webpack_require__(19590);
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/components/customer-form/components/income-tier-field/index.tsx
var income_tier_field = __webpack_require__(41052);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/components/customer-form/components/income-type-field/index.tsx
var income_type_field = __webpack_require__(86708);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/components/customer-form/components/payment-frequency-field/index.tsx
var payment_frequency_field = __webpack_require__(4187);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/constants/lib/src/index.js
var src = __webpack_require__(13294);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./src/client/ahm-constants/ui.ts
var ui = __webpack_require__(93590);
// EXTERNAL MODULE: ./src/client/actions/product/index.ts
var product = __webpack_require__(15311);
// EXTERNAL MODULE: ./src/client/models/product/index.ts + 32 modules
var models_product = __webpack_require__(43735);
// EXTERNAL MODULE: ./src/client/selectors/select-last-viewed-product/index.ts
var select_last_viewed_product = __webpack_require__(77901);
// EXTERNAL MODULE: ./src/utils/uncap-fp-iterator.ts
var uncap_fp_iterator = __webpack_require__(96852);
;// CONCATENATED MODULE: ./src/client/pages/refine-price/form/product-type-field/index.tsx













var getProduct = models_product/* default.getProduct */.Z.getProduct;
var mapWithKey = (0,uncap_fp_iterator/* default */.Z)(fp.map);
var defaultCoverTypes = mapWithKey(function(type, key) {
    return {
        text: type,
        value: (0,fp.toLower)(key)
    };
}, ui.TYPE_LABEL);
var ProductTypeField = function(param) {
    var handleChangeProductType = param.handleChangeProductType;
    var lastViewedProductId = (0,es/* useSelector */.v9)(select_last_viewed_product/* default */.Z);
    var products = (0,es/* useSelector */.v9)(function(state) {
        return state.product.data;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var hasLastViewedProduct = !(0,fp.isNil)(lastViewedProductId);
    var lastViewedProduct = hasLastViewedProduct ? getProduct(products, lastViewedProductId) : null;
    var setFieldValue = (0,formik_esm.useFormikContext)().setFieldValue;
    (0,react.useEffect)(function() {
        if (hasLastViewedProduct && (0,fp.isEmpty)(lastViewedProduct)) {
            var action = product/* default.load */.Z.load(lastViewedProductId);
            dispatch(action);
        }
    }, [
        dispatch,
        hasLastViewedProduct,
        lastViewedProduct,
        lastViewedProductId
    ]);
    // The lastViewedProduct property on the customer state could contain a product id
    // if the customer has previously viewed the product details. If this is the case,
    // the type of this lastViewedProduct is used as the default product type
    (0,react.useEffect)(function() {
        if (!(0,fp.isEmpty)(lastViewedProduct)) {
            var productType = lastViewedProduct.type === src.PRODUCT_TYPE.COMBINED ? src.PRODUCT_TYPE.PACKAGE : lastViewedProduct.type;
            setFieldValue("productType", productType);
            handleChangeProductType(productType);
        }
    }, [
        handleChangeProductType,
        lastViewedProduct,
        setFieldValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* FormikField */.Ub, {
        inputVariant: [
            "button",
            "fullWidth"
        ],
        label: "Select your health cover type",
        name: "productType",
        options: [
            {
                text: "Please select",
                value: ""
            }
        ].concat((0,_to_consumable_array/* default */.Z)(defaultCoverTypes)),
        // @ts-expect-error - Automatic, Please fix when editing this file
        onChange: function(param) {
            var value = param.target.value;
            setFieldValue("productType", value);
            handleChangeProductType(value);
        },
        size: "auto",
        type: "dropdown"
    });
};
/* harmony default export */ var product_type_field = (ProductTypeField);

// EXTERNAL MODULE: ./src/client/components/pricing-drawer/components/customer-form/components/scale-field/index.tsx
var scale_field = __webpack_require__(57593);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/components/customer-form/components/state-field/index.tsx
var state_field = __webpack_require__(80501);
;// CONCATENATED MODULE: ./src/client/pages/refine-price/form/refine-price-form-fields/index.tsx













var RefinePriceFormFields = function(param) {
    var handleChangeProductType = param.handleChangeProductType, hasSubmitAttempt = param.hasSubmitAttempt, _showPaymentFrequency = param.showPaymentFrequency, showPaymentFrequency = _showPaymentFrequency === void 0 ? true : _showPaymentFrequency;
    var location = (0,es/* useSelector */.v9)((0,fp.get)("router.location"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(scale_field/* default */.Z, {
                label: "I’m looking for..."
            }),
            handleChangeProductType && /*#__PURE__*/ (0,jsx_runtime.jsx)(product_type_field, {
                handleChangeProductType: handleChangeProductType
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(state_field/* default */.Z, {
                label: "Living in"
            }),
            showPaymentFrequency && /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_frequency_field/* default */.Z, {
                label: "Payment frequency",
                variant: "marginBottomSpacer11",
                location: location
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H5, {
                variant: "marginBottomSpacer10",
                children: "Your government rebate"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.P, {
                variant: "marginBottomSpacer8",
                children: [
                    "If you’re eligible for Medicare, the government may pay a percentage of your premium through the",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                        to: ahm_constants/* default.URLS.HELP.WHAT_IS_AGR */.Z.URLS.HELP.WHAT_IS_AGR,
                        inNewTab: true,
                        children: "Australian Government Rebate (AGR)"
                    }),
                    " ",
                    "depending on your age and income."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(age_field/* default */.Z, {
                showTooltip: false,
                isProductWithHospitalServices: true,
                hasSubmitAttempt: hasSubmitAttempt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(income_type_field/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(income_tier_field/* default */.Z, {
                showTooltip: true,
                showExplainer: false
            })
        ]
    });
};
/* harmony default export */ var refine_price_form_fields = (RefinePriceFormFields);


/***/ }),

/***/ 25034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16310);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ahmdigital_form_validation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91843);
/* harmony import */ var _ahmdigital_form_validation__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_form_validation__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13294);
/* harmony import */ var _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_constants__WEBPACK_IMPORTED_MODULE_3__);




var integer = _ahmdigital_form_validation__WEBPACK_IMPORTED_MODULE_2__.messageDefaults.integer, minAge = _ahmdigital_form_validation__WEBPACK_IMPORTED_MODULE_2__.messageDefaults.minAge, minAgePartner = _ahmdigital_form_validation__WEBPACK_IMPORTED_MODULE_2__.messageDefaults.minAgePartner, required = _ahmdigital_form_validation__WEBPACK_IMPORTED_MODULE_2__.messageDefaults.required, validAge = _ahmdigital_form_validation__WEBPACK_IMPORTED_MODULE_2__.messageDefaults.validAge;
var refinePriceSchema = (0,yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry)({
    age: (0,yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx)().typeError(integer).required("Enter your age").positive().integer(integer).min(16, minAge).max(120, validAge),
    frequency: (0,yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_)().required(required),
    incomeTier: (0,yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_)().required(required),
    incomeType: (0,yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_)().required(required),
    partnerAge: (0,yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx)().typeError(integer).nullable().when("scale", {
        is: function(value) {
            return !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.includes)(value, [
                _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_3__.SCALE.SINGLE,
                _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_3__.SCALE.SINGLE_PARENT
            ]);
        },
        then: function(rule) {
            return rule.required("Enter your partner’s age").integer(integer).min(16, minAgePartner).max(120, validAge);
        }
    }),
    productType: (0,yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_)().required("Choose a health cover type"),
    rebate: (0,yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7)().required(required),
    scale: (0,yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_)().required(required),
    state: (0,yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_)().required(required)
});
/* harmony default export */ __webpack_exports__["Z"] = (refinePriceSchema);


/***/ }),

/***/ 51890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _components_pricing_drawer_utils_get_updated_fields__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48906);
/* harmony import */ var _utils_submit_updated_refine_fields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98170);


var buildSubmitHandler = function(param) {
    var actions = param.actions, formValues = param.formValues, initialValues = param.initialValues, customer = param.customer;
    var scale = customer.scale, rebate = customer.rebate;
    var updatedFields = (0,_components_pricing_drawer_utils_get_updated_fields__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        formValues: formValues,
        initialValues: initialValues,
        scale: scale
    });
    (0,_utils_submit_updated_refine_fields__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        actions: actions,
        rebate: rebate,
        scale: scale,
        updatedFields: updatedFields
    });
    actions.customer.changeHasRefinedPrice(true);
};
/* harmony default export */ __webpack_exports__["Z"] = (buildSubmitHandler);


/***/ }),

/***/ 54251:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var selectBuildYourCover = function(state) {
    return state.buildYourCover;
};
/* harmony default export */ __webpack_exports__["Z"] = (selectBuildYourCover);


/***/ }),

/***/ 82178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ select_filtered_products_by_customer; }
});

// EXTERNAL MODULE: ./node_modules/reselect/es/index.js
var es = __webpack_require__(22222);
// EXTERNAL MODULE: ./src/client/utils/get-filtered-products/index.ts
var get_filtered_products = __webpack_require__(5490);
// EXTERNAL MODULE: ./src/client/selectors/select-customer/index.ts + 2 modules
var select_customer = __webpack_require__(34112);
;// CONCATENATED MODULE: ./src/client/selectors/select-product-ids-to-load-from-params/index.ts
// @ts-expect-error - Automatic, Please fix when editing this file
var ref;
var selectProductIdsFromParams = function(state, props) {
    var ref1, ref2;
    return (ref = props === null || props === void 0 ? void 0 : (ref1 = props.match) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.params) === null || ref2 === void 0 ? void 0 : ref2.productIds) !== null && ref !== void 0 ? ref : null;
};
/* harmony default export */ var select_product_ids_to_load_from_params = (selectProductIdsFromParams);

// EXTERNAL MODULE: ./src/client/selectors/select-products/index.ts
var select_products = __webpack_require__(2664);
;// CONCATENATED MODULE: ./src/client/selectors/select-filtered-products-by-customer/index.ts





var selectFilteredProductsByCustomer = (0,es.createSelector)([
    select_customer/* default */.Z,
    select_product_ids_to_load_from_params,
    select_products/* default */.Z
], function(customer, productIds, products) {
    if (!(customer === null || customer === void 0 ? void 0 : customer.hospitalExcess)) {
        return null;
    }
    return (0,get_filtered_products/* default */.Z)({
        customer: customer,
        productIds: productIds,
        products: products
    });
});
/* harmony default export */ var select_filtered_products_by_customer = (selectFilteredProductsByCustomer);


/***/ }),

/***/ 7473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kv": function() { return /* binding */ ProductType; }
/* harmony export */ });
/* unused harmony exports ChannelType, ClaimType, SearchTypes */
/* eslint-disable */ var ChannelType;
(function(ChannelType) {
    ChannelType["Email"] = "email";
    ChannelType["Sms"] = "sms";
})(ChannelType || (ChannelType = {}));
var ClaimType;
(function(ClaimType) {
    ClaimType["Ambulance"] = "ambulance";
    ClaimType["Hospital"] = "hospital";
    ClaimType["Medical"] = "medical";
})(ClaimType || (ClaimType = {}));
var ProductType;
(function(ProductType) {
    ProductType["Extras"] = "extras";
    ProductType["Hospital"] = "hospital";
})(ProductType || (ProductType = {}));
var SearchTypes;
(function(SearchTypes) {
    SearchTypes["Doctor"] = "doctor";
    SearchTypes["Hospital"] = "hospital";
    SearchTypes["Provider"] = "provider";
})(SearchTypes || (SearchTypes = {}));


/***/ }),

/***/ 51552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _get_future_date__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84701);
/* harmony import */ var _models_price__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2798);


var getCustomerHasChanged = function(customer, useFutureEffectiveDate) {
    var emptyProductId = "";
    return _models_price__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getKey */ .Z.getKey(emptyProductId, customer, {
        date: (0,_get_future_date__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(useFutureEffectiveDate)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (getCustomerHasChanged);


/***/ }),

/***/ 5490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _models_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43735);


// Fetches products based on id's and filters them based on scale and state
// @ts-expect-error - Automatic, Please fix when editing this file
var getFilteredProducts = function(param) {
    var customer = param.customer, productIds = param.productIds, products = param.products;
    // Get the products.
    var scale = customer.scale, state = customer.state;
    var resolvedProducts = _models_product__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getProducts */ .Z.getProducts(products, productIds);
    // Remove products based on customer state and scale.
    var filteredByStateAndScale = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.filter)(function(product) {
        return _models_product__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isAvailableIn */ .Z.isAvailableIn(product, state) && _models_product__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isAvailableFor */ .Z.isAvailableFor(product, scale);
    }, resolvedProducts);
    // If we have no products left or we get an error, bail.
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(filteredByStateAndScale) || (products === null || products === void 0 ? void 0 : products.error)) {
        return null;
    }
    return filteredByStateAndScale;
};
/* harmony default export */ __webpack_exports__["Z"] = (getFilteredProducts);


/***/ }),

/***/ 84701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _features_premium_change_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47569);

var getFutureDate = function(useFutureEffectiveDate) {
    return useFutureEffectiveDate ? _features_premium_change_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FUTURE_EFFECTIVE_DATE */ .Z.FUTURE_EFFECTIVE_DATE : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (getFutureDate);


/***/ }),

/***/ 31063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);

var hospitalExcessToOptions = function(hospitalExcess) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(value) {
        return {
            text: "$".concat(value),
            value: "".concat(value)
        };
    }, hospitalExcess);
};
/* harmony default export */ __webpack_exports__["Z"] = (hospitalExcessToOptions);


/***/ }),

/***/ 591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93590);


// @ts-expect-error - Automatic, Please fix when editing this file
var isProductBestSeller = function(param) {
    var scale = param.scale, parentProductId = param.parentProductId, productId = param.productId, productType = param.productType;
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly hospital: { readonly single: "starter-bronze"; readonly couple: "simple-bronze-plus"; readonly family: "essentials-silver-plus"; readonly "single-parent": "core-bronze-plus"; }; readonly extras: { ...; }; readonly package: { ...; }; }'.
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.some)(function(id) {
        var ref;
        return id === (_ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__.BEST_SELLERS_PRODUCT_LIST === null || _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__.BEST_SELLERS_PRODUCT_LIST === void 0 ? void 0 : (ref = _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__.BEST_SELLERS_PRODUCT_LIST[productType]) === null || ref === void 0 ? void 0 : ref[scale]);
    }, (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.compact)([
        parentProductId,
        productId
    ]));
};
/* harmony default export */ __webpack_exports__["Z"] = (isProductBestSeller);


/***/ }),

/***/ 59794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export serviceMapper */
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _get_future_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84701);
/* harmony import */ var _is_product_best_seller__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(591);
/* harmony import */ var _models_price__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2798);
/* harmony import */ var _models_url__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26789);





// @ts-expect-error - Automatic, Please fix when editing this file
var serviceMapper = function(feature) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(param) {
        var id = param.id, name = param.name;
        return {
            id: id,
            name: name
        };
    }, feature.services);
};
var prepareProductForProductTile = function(param) {
    var customer = param.customer, frequency = param.frequency, prices = param.prices, mlsAmount = param.mlsAmount, useFutureEffectiveDate = param.useFutureEffectiveDate;
    // @ts-expect-error - Automatic, Please fix when editing this file
    return function(product) {
        var ref;
        if (!product) {
            return null;
        }
        var id = product.id, additionalDetails = product.additionalDetails, charges = product.charges, content = product.content, ctaText = product.ctaText, extras = product.extras, features = product.features, hospital = product.hospital, hospitalTier = product.hospitalTier, name = product.name, rank = product.rank, type = product.type, ctaProductId = product.ctaProductId, parentProductId = product.parentProductId, unavailableWithExcessInfo = product.unavailableWithExcessInfo;
        var scale = customer.scale;
        var date = (0,_get_future_date__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(useFutureEffectiveDate);
        var price = _models_price__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getPrice */ .Z.getPrice(prices, id, customer, {
            date: date
        });
        var priceObject = price ? _models_price__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getAmountAsObject */ .Z.getAmountAsObject(price, frequency) : undefined;
        var saving = mlsAmount && priceObject ? Math.max(mlsAmount - parseFloat("".concat(priceObject.dollars, ".").concat(priceObject.cents)), 0) : undefined;
        var ref1;
        var hospitalFeatured = (ref1 = product === null || product === void 0 ? void 0 : (ref = product.hospital) === null || ref === void 0 ? void 0 : ref.featured) !== null && ref1 !== void 0 ? ref1 : [];
        var hospitalServices = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.flatMap)(serviceMapper, hospitalFeatured);
        return {
            additionalDetails: additionalDetails,
            charges: charges,
            content: content,
            ctaText: ctaText,
            extras: extras,
            features: features,
            frequency: frequency,
            hospital: hospital,
            hospitalTier: hospitalTier,
            id: id,
            isAvailable: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(scale, product.scales.supported),
            isBestSeller: (0,_is_product_best_seller__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                parentProductId: parentProductId,
                productId: id,
                productType: type,
                scale: scale
            }),
            name: name,
            price: priceObject,
            rank: rank,
            saving: saving,
            scale: customer.scale,
            services: hospitalServices,
            type: type,
            unavailableWithExcessInfo: unavailableWithExcessInfo,
            url: _models_url__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getProductUrl */ .Z.getProductUrl(ctaProductId || id)
        };
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (prepareProductForProductTile);



/***/ }),

/***/ 95327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _prepare_product_for_product_tile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59794);


var prepareProductsForProductTiles = function(allProducts, customer, prices, useFutureEffectiveDate) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)((0,_prepare_product_for_product_tile__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        customer: customer,
        frequency: customer.frequency,
        mlsAmount: undefined,
        prices: prices,
        useFutureEffectiveDate: useFutureEffectiveDate
    }), allProducts);
};
/* harmony default export */ __webpack_exports__["Z"] = (prepareProductsForProductTiles);


/***/ }),

/***/ 18971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



// @ts-expect-error - Automatic, Please fix when editing this file
var NextRedirect = function(param) {
    var to = param.to;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        router.push(to);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
var RedirectAdapter = function(param) {
    var to = param.to;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NextRedirect, {
        to: to
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RedirectAdapter);


/***/ }),

/***/ 85500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X5": function() { return /* binding */ scrollTo; },
/* harmony export */   "kI": function() { return /* binding */ scrollToElement; },
/* harmony export */   "wA": function() { return /* binding */ getScrollPosition; }
/* harmony export */ });
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _get_is_server__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41105);


// Due to Firefox / Chrome following different standards. https://miketaylr.com/posts/2014/11/document-body-scrollTop.html
function getScrollPosition() {
    return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
}
function scrollTo() {
    var to = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var isServer = (0,_get_is_server__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    if (isServer) {
        return;
    }
    window.scrollTo({
        behavior: "smooth",
        top: to
    });
    // this is used for `back to top` button after being clicked, return tab order to where it has id `backToTopPoint`
    var backToTopPoint = document.getElementById("backToTopPoint");
    if (backToTopPoint) {
        backToTopPoint.focus({
            preventScroll: true
        });
    }
}
function scrollToElement(element) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isNull)(element)) {
        return;
    }
    var scrollPosition = element.getBoundingClientRect().top + getScrollPosition() + offset;
    scrollTo(scrollPosition);
}


/***/ }),

/***/ 90937:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","section":"styles_section__LLK5Q"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1372,1849,9143,7022,9774,2888,179], function() { return __webpack_exec__(63580); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);